// Build Your Own Hamper JavaScript
// Handles all functionality for the multi-step hamper builder

console.log('🎯 Build Your Own Hamper script loaded - v2.0 with shopifyProductId tracking');

const BuildYourOwnHamper = {
  // State Management
  state: {
    currentStep: 1,
    selectedBox: null,
    selectedItems: [],
    personalisations: {},
    logoPersonalisations: {},
    giftWrap: {
      selfWrap: false,
      paperQuantities: {},
      penSellotape: false,
      wrappedItems: {}
    },
    messaging: {
      giftTag: true,
      giftTagTo: '',
      giftTagFrom: '',
      giftMessage: '',
      leaveBlank: false,
      boxPersonalisation: '',
      boxInsideMessage: '',
      boxOutsideMessage: ''
    },
    selectedThemedCard: null,
    isEditingMode: false,
    originalHamperId: null,
    filters: {
      search: '',
      searchMobile: '',
      hideOutOfStock: true,
      priceMin: 0,
      priceMax: 1000,
      categories: [],
      occasions: [],
      personalised: [],
      recipients: [],
      sizes: [],
      vendors: [],
      availabilities: [],
      christmasTypes: [],
      customFilters: {} // Dynamic storage for custom filters
    },
    currentPage: 1,
    itemsPerPage: 18,
    allProducts: [],
    filteredProducts: []
  },

  LOGO_PERSONALISATION_PRICE: 0,

  // Initialize
  init() {
    this.cacheDOMElements();
    this.bindEvents();

    // Check if we're editing an existing hamper from cart
    this.checkForEditingHamperData();

    this.loadProgress();
    this.loadProducts();
    this.initializeFilters();
    this.updateUI();
    this.setupThemedCardUpgrade();
    // Sync gift wrap visibility with the restored/selected box (if any)
    this.updateGiftWrapMode();
    this.goToStep(this.state.currentStep || 1);
    this.syncBoxSelectionUI();

    // Handle window resize
    window.addEventListener('resize', () => {
      this.updateStickyBars();
    });

    // Load progress from localStorage (again, as per your original code)
    this.loadProgress();
  },

  // Cache DOM elements for performance
  cacheDOMElements() {
    this.elements = {
      // Steps
      steps: document.querySelectorAll('.hamper-step'),
      stepContents: document.querySelectorAll('.step-content'),

      // Step 1: Box Selection
      boxOptions: document.querySelectorAll('.box-option'),
      continueToItems: document.getElementById('continue-to-items'),

      // Step 2: Items
      itemsGrid: document.getElementById('items-grid'),
      itemsSearch: document.getElementById('items-search-input'),
      itemsSearchMobile: document.getElementById('items-search-input-mobile'),
      hideOutOfStock: document.getElementById('hide-out-of-stock'),
      priceMinRange: document.getElementById('price-min-range'),
      priceMaxRange: document.getElementById('price-max-range'),
      priceMinDisplay: document.getElementById('price-min-display'),
      priceMaxDisplay: document.getElementById('price-max-display'),
      priceMinInput: document.getElementById('price-min-input'),
      priceMaxInput: document.getElementById('price-max-input'),
      sortSelect: document.getElementById('sort-select'),
      sortSelectDesktop: document.getElementById('sort-select-desktop'),
      filterOptions: document.querySelectorAll('.filter-option input'),
      itemsCount: document.getElementById('items-count'),
      itemsTotal: document.getElementById('items-total'),
      itemsPagination: document.getElementById('items-pagination'),
      openFiltersMobile: document.getElementById('open-filters-mobile'),
      closeFiltersMobile: document.getElementById('close-filters-mobile'),
      closeFiltersMobileBuild: document.getElementById('close-filters-mobile-build'),
      viewItemsMobile: document.getElementById('view-items-mobile'),
      itemsSidebar: document.getElementById('items-sidebar'),
      clearAllFilters: document.getElementById('clear-all-filters'),
      activeFiltersContainer: document.getElementById('active-filters'),

      // Step 3: Personalise
      personalisationItems: document.getElementById('personalisation-items'),
      continueToMessaging: document.getElementById('continue-to-messaging'),

      // Step 4: Gift Wrap
      giftWrapYourselfToggle: document.getElementById('gift-wrap-yourself-toggle'),
      giftWrapPaperPanel: document.getElementById('gift-wrap-paper-panel'),
      giftWrapPaperGrid: document.getElementById('gift-wrap-paper-grid'),
      giftWrapPenToggle: document.getElementById('gift-wrap-pen-toggle'),
      giftWrapItemsList: document.getElementById('gift-wrap-items-list'),
      continueToMessagingFromGiftWrap: document.getElementById('continue-to-messaging-from-gift-wrap'),

      // Step 5: Messaging
      giftTagFields: document.getElementById('gift-tag-fields'),
      giftTagTo: document.getElementById('gift-tag-to'),
      giftTagFrom: document.getElementById('gift-tag-from'),
      leaveBlankCheckbox: document.getElementById('leave-blank-checkbox'),
      giftMessage: document.getElementById('gift-message'),
      messageCount: document.getElementById('message-count'),
      luxuryBoxMessaging: document.getElementById('luxury-box-messaging'),
      boxPersonalisation: document.getElementById('box-personalisation'),
      boxMessageFields: document.getElementById('box-message-fields'),
      boxInsideMessage: document.getElementById('box-inside-message'),
      boxOutsideMessage: document.getElementById('box-outside-message'),
      insideCount: document.getElementById('inside-count'),
      outsideCount: document.getElementById('outside-count'),
      addToBasket: document.getElementById('add-to-basket'),
      summaryBoxName: document.getElementById('summary-box-name'),
      summaryEditBox: document.getElementById('summary-edit-box'),
      summaryItemsCount: document.getElementById('summary-items-count'),
      summaryTotalPrice: document.getElementById('summary-total-price'),
      addToBasketSummary: document.getElementById('add-to-basket-summary'),
      themedCardToggle: document.getElementById('gift-card-toggle'),
      selectedCardWidget: document.getElementById('selected-card-widget'),
      weddingCardsOverlay: document.getElementById('wedding-cards-popup-overlay'),
      weddingCardsClose: document.getElementById('close-wedding-cards-popup'),
      weddingCardsWrapper: document.querySelector('.wedding-cards-swiper .swiper-wrapper'),
      addWeddingCardBtn: document.getElementById('add-wedding-card-to-cart'),
      themedCardPrice: document.getElementById('byo-themed-card-price'),
      themedCardUpgrade: document.getElementById('byo-themed-card-upgrade'),

      // Sidebar
      hamperSidebar: document.getElementById('hamper-sidebar'),
      hamperSidebarOverlay: document.getElementById('hamper-sidebar-overlay'),
      sidebarBoxName: document.getElementById('sidebar-box-name'),
      sidebarItemsList: document.getElementById('sidebar-items-list'),
      sidebarItemsCount: document.getElementById('sidebar-items-count'),
      hamperTotalPrice: document.getElementById('hamper-total-price'),
      editBox: document.getElementById('edit-box'),
      sidebarContinue: document.getElementById('sidebar-continue'),
      hamperSidebarClose: document.getElementById('hamper-sidebar-close'),

      // Navigation
      backButtons: document.querySelectorAll('.btn-back, .step-back-button'),

      // Loading
      loadingSpinner: document.querySelector('.loading'),

      // Mobile sticky bar
      mobileStickyBar: document.getElementById('mobile-sticky-bar'),
      mobileViewEdit: document.getElementById('mobile-view-edit'),
      mobileContinueBtn: document.getElementById('mobile-continue-btn'),
      mobileItemsCount: document.getElementById('mobile-items-count'),
      mobileTotalPrice: document.getElementById('mobile-total-price'),

      // Desktop sticky bar
      desktopStickyBar: document.getElementById('desktop-sticky-bar'),
      desktopViewEdit: document.getElementById('desktop-view-edit'),
      desktopContinueBtn: document.getElementById('desktop-continue-btn'),
      desktopItemsCount: document.getElementById('desktop-items-count'),
      desktopTotalPrice: document.getElementById('desktop-total-price')
    };
  },

  // Bind all events
  bindEvents() {
    // Box selection
    this.elements.boxOptions.forEach(box => {
      box.addEventListener('click', (e) => this.selectBox(e));
    });

    // Continue buttons
    this.elements.continueToItems.addEventListener('click', () => this.goToStep(2));
    // Personalise → next step. Goes to Gift Wrap (4) only if Gift Bag & Wrapping is the selected presentation.
    // Otherwise skips straight to Messaging (5).
    this.elements.continueToMessaging.addEventListener('click', () => {
      this.goToStep(this.isGiftWrapEnabled() ? 4 : 5);
    });
    if (this.elements.continueToMessagingFromGiftWrap) {
      this.elements.continueToMessagingFromGiftWrap.addEventListener('click', () => this.goToStep(5));
    }

    if (this.elements.giftWrapYourselfToggle) {
      this.elements.giftWrapYourselfToggle.addEventListener('change', (e) => {
        this.state.giftWrap.selfWrap = e.target.checked;
        if (!e.target.checked) {
          this.state.giftWrap.paperQuantities = {};
          this.state.giftWrap.penSellotape = false;
        }
        this.syncGiftWrapUI();
        this.updateTotal();
        this.saveProgress();
      });
    }

    if (this.elements.giftWrapPenToggle) {
      this.elements.giftWrapPenToggle.addEventListener('change', (e) => {
        this.state.giftWrap.penSellotape = e.target.checked;
        this.updateTotal();
        this.saveProgress();
      });
    }

    // Back buttons
    this.elements.backButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const targetStep = parseInt(e.currentTarget.getAttribute('data-go-to-step'));
        this.goToStep(targetStep);
      });
    });

    // Filters
    this.elements.itemsSearch.addEventListener('input',
      this.debounce(() => this.applyFilters(), 300)
    );
    this.elements.itemsSearchMobile.addEventListener('input',
      this.debounce(() => this.applyFilters(), 300)
    );
    

    if (this.elements.hideOutOfStock) {
      this.elements.hideOutOfStock.addEventListener('change', () => this.applyFilters());
    }

    this.elements.priceMinRange.addEventListener('input', (e) => {
      this.state.filters.priceMin = parseInt(e.target.value);
      this.updatePriceDisplay();
      this.applyFilters();
    });

    this.elements.priceMaxRange.addEventListener('input', (e) => {
      this.state.filters.priceMax = parseInt(e.target.value);
      this.updatePriceDisplay();
      this.applyFilters();
    });

    // Price input fields
    if (this.elements.priceMinInput) {
      this.elements.priceMinInput.addEventListener('change', (e) => {
        const value = parseInt(e.target.value) || 0;
        this.state.filters.priceMin = Math.max(0, Math.min(value, this.state.filters.priceMax));
        this.elements.priceMinRange.value = this.state.filters.priceMin;
        this.updatePriceDisplay();
        this.applyFilters();
      });
    }

    if (this.elements.priceMaxInput) {
      this.elements.priceMaxInput.addEventListener('change', (e) => {
        const value = parseInt(e.target.value) || 1000;
        this.state.filters.priceMax = Math.max(this.state.filters.priceMin, value);
        this.elements.priceMaxRange.value = this.state.filters.priceMax;
        this.updatePriceDisplay();
        this.applyFilters();
      });
    }

    this.elements.filterOptions.forEach(option => {
      option.addEventListener('change', () => this.applyFilters());
    });

    this.elements.sortSelect.addEventListener('change', () => {
      // Sync with desktop sort if exists
      if (this.elements.sortSelectDesktop) {
        this.elements.sortSelectDesktop.value = this.elements.sortSelect.value;
      }
      this.sortProducts();
    });

    // Desktop sort select
    if (this.elements.sortSelectDesktop) {
      this.elements.sortSelectDesktop.addEventListener('change', () => {
        // Sync the values
        this.elements.sortSelect.value = this.elements.sortSelectDesktop.value;
        this.sortProducts();
      });
    }

    // Mobile filters
    if (this.elements.openFiltersMobile) {
      this.elements.openFiltersMobile.addEventListener('click', () => {
        this.elements.itemsSidebar.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    }

    // Close filters mobile
    if (this.elements.closeFiltersMobile) {
      this.elements.closeFiltersMobile.addEventListener('click', () => {
        this.elements.itemsSidebar.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    // View items mobile button
    if (this.elements.viewItemsMobile) {
      this.elements.viewItemsMobile.addEventListener('click', () => {
        this.elements.itemsSidebar.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    // Gift tag and messaging - Leave blank checkbox
    this.elements.leaveBlankCheckbox.addEventListener('change', (e) => {
      this.state.messaging.leaveBlank = e.target.checked;

      if (e.target.checked) {
        // Clear both fields and make them optional
        this.elements.giftTagTo.value = '';
        this.elements.giftTagFrom.value = '';
        this.state.messaging.giftTagTo = '';
        this.state.messaging.giftTagFrom = '';
        this.elements.giftTagTo.required = false;
        this.elements.giftTagFrom.required = false;
        // Clear any inline errors
        this.toggleFieldError(this.elements.giftTagTo, false);
        this.toggleFieldError(this.elements.giftTagFrom, false);
      } else {
        // Fields become required again
        this.elements.giftTagTo.required = true;
        this.elements.giftTagFrom.required = true;
      }
    });

    // Track gift tag To and From changes + clear inline errors as user types
    this.elements.giftTagTo.addEventListener('input', (e) => {
      this.state.messaging.giftTagTo = e.target.value;
      if (e.target.value.trim() !== '') {
        this.toggleFieldError(this.elements.giftTagTo, false);
      }
    });

    this.elements.giftTagFrom.addEventListener('input', (e) => {
      this.state.messaging.giftTagFrom = e.target.value;
      if (e.target.value.trim() !== '') {
        this.toggleFieldError(this.elements.giftTagFrom, false);
      }
    });

    this.elements.giftMessage.addEventListener('input', (e) => {
      this.state.messaging.giftMessage = e.target.value;
      this.elements.messageCount.textContent = e.target.value.length;
    });

    // Box personalisation
    this.elements.boxPersonalisation.addEventListener('change', (e) => {
      const value = e.target.value;
      this.state.messaging.boxPersonalisation = value;

      if (value) {
        this.elements.boxMessageFields.style.display = 'block';

        // Show/hide appropriate fields
        if (value === 'inside-outside') {
          document.getElementById('inside-message-group').style.display = 'block';
          document.getElementById('outside-message-group').style.display = 'block';
        } else if (value === 'front-only') {
          document.getElementById('inside-message-group').style.display = 'none';
          document.getElementById('outside-message-group').style.display = 'block';
        }

        this.updateTotal();
      } else {
        this.elements.boxMessageFields.style.display = 'none';
      }
    });

    // Summary section events
    if (this.elements.summaryEditBox) {
      this.elements.summaryEditBox.addEventListener('click', () => {
        this.goToStep(1);
      });
    }

    if (this.elements.addToBasketSummary) {
      this.elements.addToBasketSummary.addEventListener('click', () => this.submitHamper());
    }

    // Character counters
    this.elements.boxInsideMessage.addEventListener('input', (e) => {
      this.state.messaging.boxInsideMessage = e.target.value;
      this.elements.insideCount.textContent = e.target.value.length;
    });

    this.elements.boxOutsideMessage.addEventListener('input', (e) => {
      this.state.messaging.boxOutsideMessage = e.target.value;
      this.elements.outsideCount.textContent = e.target.value.length;
    });

    // Sidebar
    this.elements.editBox.addEventListener('click', () => {
      this.goToStep(1);
    });
    this.elements.sidebarContinue.addEventListener('click', () => {
      if (this.state.currentStep === 2) {
        this.goToStep(3);
      }
    });
    if (this.elements.hamperSidebarClose) {
      this.elements.hamperSidebarClose.addEventListener('click', () => this.closeSidebar());
    }
    if (this.elements.hamperSidebarOverlay) {
      this.elements.hamperSidebarOverlay.addEventListener('click', () => this.closeSidebar());
    }

    // Mobile sticky bar events
    if (this.elements.mobileViewEdit) {
      this.elements.mobileViewEdit.addEventListener('click', () => this.openSidebar());
    }
    if (this.elements.mobileContinueBtn) {
      this.elements.mobileContinueBtn.addEventListener('click', () => {
        if (this.state.currentStep === 2) {
          this.goToStep(3);
        }
      });
    }

    // Desktop sticky bar events
    if (this.elements.desktopViewEdit) {
      this.elements.desktopViewEdit.addEventListener('click', () => this.openSidebar());
    }
    if (this.elements.desktopContinueBtn) {
      this.elements.desktopContinueBtn.addEventListener('click', () => {
        if (this.state.currentStep === 2) {
          this.goToStep(3);
        }
      });
    }

    // Add to basket
    if (this.elements.addToBasket) {
      this.elements.addToBasket.addEventListener('click', () => this.submitHamper());
    }

    // Clear all filters button
    if (this.elements.clearAllFilters) {
      this.elements.clearAllFilters.addEventListener('click', () => this.clearAllFilters());
    }

    // Update filter count when filters change
    this.updateFilterCount();
  },

  // Box selection
  selectBox(e) {
    const boxOption = e.currentTarget;
    const boxType = boxOption.getAttribute('data-box-type');
    const boxPrice = parseFloat(boxOption.getAttribute('data-box-price'));

    // Remove previous selection
    this.elements.boxOptions.forEach(box => box.classList.remove('selected'));

    // Add selection
    boxOption.classList.add('selected');

    // Update state
    this.state.selectedBox = {
      type: boxType,
      price: boxPrice,
      name: boxOption.querySelector('.box-option-title').textContent
    };

    // Handle color selection for both wicker basket AND luxury box
    if (boxType === 'wicker-basket' || boxType === 'luxury-box') {
      const colorSelect = boxOption.querySelector('.box-color');
      this.state.selectedBox.color = colorSelect.value;

      // Update image based on initial color selection
      this.updateBoxImage(boxOption, boxType, colorSelect.value);

      // Remove existing event listeners to prevent duplicates
      const existingListener = colorSelect._changeHandler;
      if (existingListener) {
        colorSelect.removeEventListener('change', existingListener);
      }

      // Add new event listener
      const changeHandler = (e) => {
        this.state.selectedBox.color = e.target.value;
        this.updateBoxImage(boxOption, boxType, e.target.value);

        // Update price for both wicker basket and luxury box when color changes
        if (window.boxPrices) {
          const priceKey = `${boxType}-${e.target.value}`;
          const newPrice = window.boxPrices[priceKey];

          if (newPrice !== undefined) {
            console.log(`Updating ${boxType} price to ${newPrice} for color: ${e.target.value}`);
            this.state.selectedBox.price = parseFloat(newPrice);
          }
        }

        this.updateSidebarBox();
        this.updateTotal();
        this.saveProgress();
      };

      colorSelect._changeHandler = changeHandler;
      colorSelect.addEventListener('change', changeHandler);
    } else {
      // Update image for non-color options (if any)
      this.updateBoxImage(boxOption, boxType);
    }

    // Enable continue button
    this.elements.continueToItems.disabled = false;

    // Toggle Gift Wrap step visibility based on selected presentation
    this.updateGiftWrapMode();

    // Update sidebar
    this.updateSidebarBox();
    this.saveProgress();
  },

  // Helper: gift wrap step is only enabled when 'Gift Bag & Wrapping' is the picked presentation
  isGiftWrapEnabled() {
    return !!(this.state.selectedBox && this.state.selectedBox.type === 'gift-bag');
  },

  // Toggle UI to reflect whether Gift Wrap step is in the flow
  updateGiftWrapMode() {
    const wrapper = document.querySelector('.hamper-content-wrapper');
    if (!wrapper) return;
    const enabled = this.isGiftWrapEnabled();
    wrapper.classList.toggle('gift-wrap-enabled', enabled);
    wrapper.classList.toggle('gift-wrap-disabled', !enabled);

    // Update the Personalise step's continue button label
    if (this.elements.continueToMessaging) {
      this.elements.continueToMessaging.textContent = enabled
        ? 'Continue to Gift Wrap'
        : 'Continue to Messaging';
    }

    // Update the Messaging step's back button so it skips the (hidden) Gift Wrap step
    const messagingBackBtn = document.querySelector('.step-content[data-step-content="5"] .step-back-button');
    if (messagingBackBtn) {
      messagingBackBtn.setAttribute('data-go-to-step', enabled ? '4' : '3');
    }

    // Safety net: if currently on step 4 and gift wrap is now disabled, fall back to step 3
    if (!enabled && this.state.currentStep === 4) {
      this.goToStep(3);
    }
  },

  // New method to handle image updates
  updateBoxImage(boxOption, boxType, color = null) {
    console.log('Updating image for:', boxType, color);
    console.log('Available images:', window.boxImages);

    const img = boxOption.querySelector('.box-option-image img');
    let imageSrc;

    if (boxType === 'wicker-basket') {
      imageSrc = window.boxImages && window.boxImages['wicker-basket'] ? window.boxImages['wicker-basket'][color || 'light'] : null;
    } else if (boxType === 'luxury-box') {
      imageSrc = window.boxImages && window.boxImages['luxury-box'] ? window.boxImages['luxury-box'][color || 'black'] : null;
    }

    console.log('Image source:', imageSrc);

    if (imageSrc && img) {
      img.src = imageSrc;
      img.alt = this.state.selectedBox.name + (color ? ` (${color})` : '');
      console.log('Image updated successfully');
    } else {
      console.log('Failed to update image - missing src or img element');
      console.log('imageSrc:', imageSrc, 'img:', img);
    }
  },

  // Navigation between steps
  goToStep(stepNumber) {
    // Update current step
    this.state.currentStep = stepNumber;

    // Show/hide sidebar and sticky bars based on step
    if (stepNumber === 2) {
      setTimeout(() => {
        this.updateStickyBars();
      }, 100);
    } else {
      this.closeSidebar();
      // Hide sticky bars
      if (this.elements.mobileStickyBar) {
        this.elements.mobileStickyBar.style.display = 'none';
      }
      if (this.elements.desktopStickyBar) {
        this.elements.desktopStickyBar.classList.remove('show');
      }
    }

    // Update step indicators
    this.elements.steps.forEach((step, index) => {
      if (index < stepNumber - 1) {
        step.classList.add('completed');
        step.classList.remove('active');
      } else if (index === stepNumber - 1) {
        step.classList.add('active');
        step.classList.remove('completed');
      } else {
        step.classList.remove('active', 'completed');
      }
    });

    // Show correct content
    this.elements.stepContents.forEach(content => {
      const contentStep = parseInt(content.getAttribute('data-step-content'));
      content.classList.toggle('active', contentStep === stepNumber);
    });

    // Step-specific logic
    if (stepNumber === 3) {
      this.setupPersonalisation();
    } else if (stepNumber === 4) {
      this.setupGiftWrap();
    } else if (stepNumber === 5) {
      this.setupMessaging();
      this.refreshThemedCardUpgradeVisibility();
    }

    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.saveProgress();
  },

  normalizeProductId(value) {
    const rawValue = value == null ? '' : String(value).trim();
    if (!rawValue || rawValue === 'null' || rawValue === 'undefined') return '';

    const gidMatch = rawValue.match(/Product\/(\d+)$/);
    if (gidMatch && gidMatch[1]) return gidMatch[1];

    const numericMatch = rawValue.match(/\d+/g);
    return numericMatch && numericMatch.length ? numericMatch[numericMatch.length - 1] : rawValue;
  },

  normalizeProductTitle(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  },

  getExcludedProductSettings() {
    const products = Array.isArray(window.buildYourOwnExcludedProducts) ? window.buildYourOwnExcludedProducts : [];
    const ids = [];
    const handles = [];
    const titles = [];

    products.forEach(product => {
      if (!product) return;

      const id = this.normalizeProductId(product.id);
      const handle = product.handle == null ? '' : String(product.handle).trim();
      const title = this.normalizeProductTitle(product.title);

      if (id) ids.push(id);
      if (handle && handle !== 'null' && handle !== 'undefined') handles.push(handle);
      if (title && title !== 'null' && title !== 'undefined') titles.push(title);
    });

    return {
      ids: [...new Set(ids)],
      handles: [...new Set(handles)],
      titles: [...new Set(titles)]
    };
  },

  isProductExcluded(product, excludedProducts) {
    if (!product || !excludedProducts) return false;

    const productId = this.normalizeProductId(product.id);
    const productHandle = product.handle ? String(product.handle) : '';
    const productTitle = this.normalizeProductTitle(product.title);

    return (productId && excludedProducts.ids.includes(productId)) ||
      (productHandle && excludedProducts.handles.includes(productHandle)) ||
      (productTitle && excludedProducts.titles && excludedProducts.titles.includes(productTitle));
  },

  isSelectedItemExcluded(item, excludedProducts = this.getExcludedProductSettings()) {
    if (!item || !excludedProducts) return false;

    return this.isProductExcluded(item, excludedProducts) ||
      this.isProductExcluded({
        id: item.shopifyProductId || item.productId || item.id,
        handle: item.handle,
        title: item.title
      }, excludedProducts);
  },

  getVisibleSelectedItems() {
    const excludedProducts = this.getExcludedProductSettings();
    if (!excludedProducts.ids.length && !excludedProducts.handles.length && !excludedProducts.titles.length) {
      return this.state.selectedItems || [];
    }

    return (this.state.selectedItems || []).filter(item => !this.isSelectedItemExcluded(item, excludedProducts));
  },

  pruneExcludedSelections() {
    const excludedProducts = this.getExcludedProductSettings();
    if (!excludedProducts.ids.length && !excludedProducts.handles.length && !excludedProducts.titles.length) return false;

    const selectedItems = this.state.selectedItems || [];
    const excludedItems = selectedItems.filter(item => this.isSelectedItemExcluded(item, excludedProducts));
    if (!excludedItems.length) return false;

    let changed = false;
    if (this.state.giftWrap && this.state.giftWrap.wrappedItems) {
      excludedItems.forEach(item => {
        const key = this.getGiftWrapItemKey(item);
        if (key && this.state.giftWrap.wrappedItems[key]) {
          delete this.state.giftWrap.wrappedItems[key];
          changed = true;
        }
        if (item.title && this.state.giftWrap.wrappedItems[item.title]) {
          delete this.state.giftWrap.wrappedItems[item.title];
          changed = true;
        }
      });
    }

    return changed;
  },

  getGridHiddenProductSettings() {
    const products = Array.isArray(window.buildYourOwnGridHiddenProducts) ? window.buildYourOwnGridHiddenProducts : [];
    const ids = [];
    const handles = ['luxury-box-with-bow-white-copy'];
    const titles = ['gift bag & wrapping'];

    products.forEach(product => {
      if (!product) return;

      const id = this.normalizeProductId(product.id);
      const handle = product.handle == null ? '' : String(product.handle).trim();
      const title = this.normalizeProductTitle(product.title);

      if (id) ids.push(id);
      if (handle && handle !== 'null' && handle !== 'undefined') handles.push(handle);
      if (title && title !== 'null' && title !== 'undefined') titles.push(title);
    });

    return {
      ids: [...new Set(ids)],
      handles: [...new Set(handles)],
      titles: [...new Set(titles)]
    };
  },

  isProductHiddenFromGrid(product, hiddenProducts = this.getGridHiddenProductSettings()) {
    return this.isProductExcluded(product, hiddenProducts);
  },

  applyProductExclusions(products) {
    if (!Array.isArray(products)) return [];

    const hiddenProducts = this.getGridHiddenProductSettings();
    return products.filter(product => !this.isProductHiddenFromGrid(product, hiddenProducts));
  },

  // Load products
  async loadProducts() {
    // Get collection handle from section settings or use default
    const collectionHandle = this.elements.itemsGrid.getAttribute('data-collection') || 'all';

    // Show loading state
    this.elements.itemsGrid.innerHTML = '<div class="loading-products">Loading products...</div>';

    try {
      let allProducts = [];
      let page = 1;
      let hasMoreProducts = true;

      // Fetch all products using pagination
      while (hasMoreProducts) {
        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=250&page=${page}`);
        const data = await response.json();

        if (data.products && data.products.length > 0) {
          const visibleProducts = this.applyProductExclusions(data.products);

          // Process and add products to our array (filtering out completely sold-out products)
          const processedProducts = visibleProducts
            .filter(product => product.variants.some(v => v.available))
            .map(product => ({
              id: product.id, // This is the Shopify product ID
              shopifyProductId: product.id, // Store explicitly to avoid confusion
              title: product.title,
              handle: product.handle,
              price: parseFloat(product.variants[0].price),
              comparePrice: product.variants[0].compare_at_price ? parseFloat(product.variants[0].compare_at_price) : null,
              available: product.variants.some(v => v.available),
              images: product.images,
              tags: product.tags,
              vendor: product.vendor,
              type: product.product_type,
              variants: product.variants,
              canPersonalise: product.tags.some(tag => tag.startsWith('personalise:') || tag === 'personalise'),
              canPersonaliseLogo: product.tags.some(tag => ['personalise:logo', 'personalise:logo0'].includes(tag.toLowerCase())),
              personalisationType: this.getPersonalisationType(product.tags),
              personalisationPrice: this.getPersonalisationPrice(product.tags)
            }));

          allProducts = allProducts.concat(processedProducts);

          // Check if we've received a full page of products
          if (data.products.length < 250) {
            hasMoreProducts = false;
          } else {
            page++;
          }

          // Update loading message with progress
          if (this.elements.itemsGrid.querySelector('.loading-products')) {
            this.elements.itemsGrid.innerHTML = `<div class="loading-products">Loading products... (${allProducts.length} loaded)</div>`;
          }
        } else {
          hasMoreProducts = false;
        }

        // Add a small delay to avoid rate limiting
        if (hasMoreProducts) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }

      this.state.allProducts = allProducts;

      // Clear loading message
      this.elements.itemsGrid.innerHTML = '';

      // Initialize products display
      this.applyFilters();

      console.log(`Loaded ${allProducts.length} products from collection ${collectionHandle}`);

    } catch (error) {
      console.error('Error loading products:', error);
      this.elements.itemsGrid.innerHTML = '<div class="error-message">Error loading products. Please refresh the page and try again.</div>';
    }
  },

  // Initialize filter values
  initializeFilters() {
    // Get min/max prices from settings
    const minPrice = parseInt(this.elements.priceMinRange.getAttribute('min'));
    const maxPrice = parseInt(this.elements.priceMaxRange.getAttribute('max'));
    const defaultMax = parseInt(this.elements.priceMaxRange.getAttribute('value'));

    this.state.filters.priceMin = minPrice;
    this.state.filters.priceMax = defaultMax || maxPrice || 1000;

    this.updatePriceDisplay();
  },

  // Apply filters and display products
  applyFilters() {
    // Reset to page 1 when filters change
    this.state.currentPage = 1;

    // Get filter values
    this.state.filters.search = this.elements.itemsSearch.value.toLowerCase();
    this.state.filters.searchMobile = this.elements.itemsSearchMobile.value.toLowerCase();
this.state.filters.hideOutOfStock = this.elements.hideOutOfStock.checked;

    // Get selected filter options - DYNAMIC APPROACH
    const filterGroups = {
      category: [],
      occasion: [],
      recipient: [],
      size: [],
      vendor: [],
      availability: [],
      christmas_type: [],
      personalised: []
    };

    // Collect all checked filters dynamically
    this.elements.filterOptions.forEach(option => {
      if (option.checked) {
        const filterType = option.getAttribute('data-filter-type');
        const filterValue = option.getAttribute('data-filter-value').trim();

        // If it's a known filter type, add to that array
        if (filterGroups[filterType]) {
          filterGroups[filterType].push(filterValue);
        } else {
          // For custom/dynamic filter types, store in customFilters
          if (!filterGroups[filterType]) {
            filterGroups[filterType] = [];
          }
          filterGroups[filterType].push(filterValue);
        }
      }
    });

    // Update state with collected filters
    this.state.filters.categories = filterGroups.category || [];
    this.state.filters.occasions = filterGroups.occasion || [];
    this.state.filters.personalised = filterGroups.personalised || [];
    this.state.filters.recipients = filterGroups.recipient || [];
    this.state.filters.sizes = filterGroups.size || [];
    this.state.filters.vendors = filterGroups.vendor || [];
    this.state.filters.availabilities = filterGroups.availability || [];
    this.state.filters.christmasTypes = filterGroups.christmas_type || [];
    
    // Store all custom filters
    this.state.filters.customFilters = {};
    Object.keys(filterGroups).forEach(key => {
      if (!['category', 'occasion', 'personalised', 'recipient', 'size', 'vendor', 'availability', 'christmas_type'].includes(key)) {
        this.state.filters.customFilters[key] = filterGroups[key];
      }
    });

    // Filter products
    this.state.filteredProducts = this.state.allProducts.filter(product => {
      // Search filter - check title and tags
      if (this.state.filters.search) {
        const searchTerm = this.state.filters.search;
        const titleMatch = product.title.toLowerCase().includes(searchTerm);
        const tagMatch = product.tags.some(tag => tag.toLowerCase().includes(searchTerm));
        if (!titleMatch && !tagMatch) return false;
      }
      if (this.state.filters.searchMobile) {
        const searchTerm = this.state.filters.searchMobile;
        const titleMatch = product.title.toLowerCase().includes(searchTerm);
        const tagMatch = product.tags.some(tag => tag.toLowerCase().includes(searchTerm));
        if (!titleMatch && !tagMatch) return false;
      }
      

      // Stock filter
      if (this.state.filters.hideOutOfStock && !product.available) {
        return false;
      }

      // Price filter
      if (product.price < this.state.filters.priceMin || product.price > this.state.filters.priceMax) {
        return false;
      }

      // Category filter
            if (this.state.filters.categories.length > 0) {
                const hasCategory = this.state.filters.categories.some(cat => {
                    return product.tags.some(tag =>
                        tag.toLowerCase() === `category:${cat.toLowerCase()}` ||
                        tag.toLowerCase() === cat.toLowerCase()
                    ) || product.type.toLowerCase() === cat.toLowerCase();
                });
                if (!hasCategory) return false;
            }

            // Occasion filter
            if (this.state.filters.occasions.length > 0) {
              
                const hasOccasion = this.state.filters.occasions.some(occ => {
                 
                    return product.tags.some(tag =>
                        tag.toLowerCase() === `occasion:${occ.toLowerCase()}` ||
                        tag.toLowerCase() === occ.toLowerCase()
                    );
                });
                console.log('Occasion filter check:', this.state.filters.occasions, 'Product:', product.title, 'Has occasion:', hasOccasion);
                if (!hasOccasion) return false;
            }

            // Personalise filter
            if (this.state.filters.personalised.length > 0) {
                const hasPersonalised = this.state.filters.personalised.some(item => {
                    const tagsLower = product.tags.map(tag => tag.toLowerCase());
                    return (
                        tagsLower.some(tag => tag.startsWith('personalise')) &&
                        tagsLower.includes(item.toLowerCase())
                    );
                });
                if (!hasPersonalised) return false;
            }

            // Recipient filter
            if (this.state.filters.recipients.length > 0) {
                const hasRecipient = this.state.filters.recipients.some(rec => {
                    return product.tags.some(tag =>
                        tag.toLowerCase() === `recipient:${rec.toLowerCase()}` ||
                        tag.toLowerCase() === rec.toLowerCase()
                    );
                });
                if (!hasRecipient) return false;
            }

            // Size filter
            if (this.state.filters.sizes.length > 0) {
                const hasSize = this.state.filters.sizes.some(size => {
                    return product.tags.some(tag =>
                        tag.toLowerCase() === `size:${size.toLowerCase()}` ||
                        tag.toLowerCase() === size.toLowerCase()
                    );
                });
                if (!hasSize) return false;
            }

            // Vendor filter
            if (this.state.filters.vendors.length > 0 && !this.state.filters.vendors.includes('all')) {
                const vendorMatch = this.state.filters.vendors.some(vendor =>
                    product.vendor.toLowerCase() === vendor.toLowerCase()
                );
                if (!vendorMatch) return false;
            }

            // Availability filter
            if (this.state.filters.availabilities.length > 0) {
                const hasAvailability = this.state.filters.availabilities.some(avail => {
                    return product.tags.some(tag =>
                        tag.toLowerCase() === `availability:${avail.toLowerCase()}` ||
                        tag.toLowerCase() === avail.toLowerCase() ||
                        tag.toLowerCase() === avail.toLowerCase().replace(/\s+/g, '-')
                    );
                });
                if (!hasAvailability) return false;
            }

            // Christmas Type filter
            if (this.state.filters.christmasTypes.length > 0) {
                const hasChristmasType = this.state.filters.christmasTypes.some(type => {
                    return product.tags.some(tag =>
                        tag.toLowerCase() === `christmas_type:${type.toLowerCase()}` ||
                        tag.toLowerCase() === type.toLowerCase()
                    );
                });
                if (!hasChristmasType) return false;
            }

      // DYNAMIC CUSTOM FILTERS - handles any filter type from theme customizer
      for (const [filterType, filterValues] of Object.entries(this.state.filters.customFilters)) {
        if (filterValues && filterValues.length > 0) {
          const hasMatch = filterValues.some(value => {
            return product.tags.some(tag =>
              tag.toLowerCase() === `${filterType}:${value.toLowerCase()}` ||
              tag.toLowerCase() === value.toLowerCase()
            );
          });
          if (!hasMatch) return false;
        }
      }

      return true;
    });

    // Sort products
    this.sortProducts();

    // Display products
    this.displayProducts();

    // Update filter count
    this.updateFilterCount();
  },

  // Sort products
  sortProducts() {
    // Reset to page 1 when sort changes
    this.state.currentPage = 1;

    const sortValue = this.elements.sortSelect.value;

    switch (sortValue) {
      case 'price-low-high':
        this.state.filteredProducts.sort((a, b) => a.price - b.price);
        break;
      case 'price-high-low':
        this.state.filteredProducts.sort((a, b) => b.price - a.price);
        break;
      case 'newest':
        // Would need created_at date from product data
        break;
      case 'best-sellers': 
      default: // Keep original order break;
    }

    this.displayProducts();
  },

  // Display products with pagination
  displayProducts() {
    const startIndex = (this.state.currentPage - 1) * this.state.itemsPerPage;
    const endIndex = startIndex + this.state.itemsPerPage;
    const productsToShow = this.state.filteredProducts.slice(startIndex, endIndex);

    // Clear grid
    this.elements.itemsGrid.innerHTML = '';

    // Add products
    productsToShow.forEach(product => {
      const productCard = this.createProductCard(product);
      this.elements.itemsGrid.appendChild(productCard);
    });

    // Update counts
    this.elements.itemsCount.textContent = productsToShow.length;
    this.elements.itemsTotal.textContent = this.state.filteredProducts.length;

    // Show/hide no results
    const noResults = this.elements.itemsGrid.parentElement.querySelector('.no-results');
    if (this.state.filteredProducts.length === 0) {
      noResults.style.display = 'block';
    } else {
      noResults.style.display = 'none';
    }

    // Update pagination
    this.updatePagination();
  },

  // -----------------------------
  // UPDATED: Create product card
  // Enforces sold-out behavior + disables add for unavailable variants
  // -----------------------------
  createProductCard(product) {
    const card = document.createElement('div');
    card.className = 'item-card';

    const variants = Array.isArray(product.variants) ? product.variants : [];
    const hasVariants = variants.length > 0;

    // Find first available variant (if any)
    const firstAvailableVariant = hasVariants ? variants.find(v => v.available) : null;
    const allSoldOut = hasVariants ? !firstAvailableVariant : !product.available;

    // Determine initial variant choice (prefer first available)
    const initialVariant = firstAvailableVariant || (hasVariants ? variants[0] : null);
    const initialVariantId = initialVariant ? initialVariant.id : product.id;

    const isSelectedForInitial = this.state.selectedItems.some(item => item.id === initialVariantId);

    if (allSoldOut) card.classList.add('is-sold-out');

    card.innerHTML = `
      <div class="item-card-image">
        <img src="${product.images[0]?.src || ''}" alt="${product.title}" loading="lazy">

        ${allSoldOut ? `<div class="item-card-soldout-badge">Sold out</div>` : ''}

        <button
          class="imhere add-item-btn ${isSelectedForInitial ? 'remove-item-btn' : ''}"
          data-product-id="${initialVariantId}"
          ${(!isSelectedForInitial && allSoldOut) ? 'disabled aria-disabled="true"' : ''}
        >
          ${isSelectedForInitial ? '✕' : '+'}
        </button>
      </div>

      <div class="item-card-content">
        <h4 class="item-card-title">${product.title}</h4>

        ${hasVariants && variants.length > 1 ? `
          <select class="item-card-variant-picker">
            ${variants.map(variant => `
              <option value="${variant.id}" data-price="${variant.price}" ${variant.available ? '' : 'disabled'} ${variant.id === initialVariantId ? 'selected' : ''}>
                ${variant.title}${variant.available ? '' : ' (Sold out)'}
              </option>
            `).join('')}
          </select>
        ` : ''}

        <div class="item-card-description" data-desc style="display:none;"></div>

        <div class="item-card-price">
          ${product.comparePrice
            ? `<span class="price-sale">£${Number(product.price).toFixed(2)}</span>
               <span class="price-compare">£${Number(product.comparePrice).toFixed(2)}</span>`
            : `£${Number(product.price).toFixed(2)}`
          }
          <a href="#" class="product-view-info" data-product-handle="${product.handle}">View Info</a>
        </div>   
      </div>
    `;

    const variantPicker = card.querySelector('.item-card-variant-picker');
    const addBtn = card.querySelector('.add-item-btn');

    const syncButtonState = (variantId) => {
      const idNum = parseInt(variantId, 10);
      const selected = this.state.selectedItems.some(item => item.id === idNum);
      const v = variants.find(x => x.id === idNum);
      const available = v ? !!v.available : !!product.available;

      // Always allow REMOVE even if sold out
      if (selected) {
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-disabled');
        addBtn.classList.add('remove-item-btn');
        addBtn.innerHTML = '✕';
        return;
      }

      // Not selected: disable if unavailable
      if (!available) {
        addBtn.disabled = true;
        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.classList.remove('remove-item-btn');
        addBtn.innerHTML = '+';
      } else {
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-disabled');
        addBtn.classList.remove('remove-item-btn');
        addBtn.innerHTML = '+';
      }
    };

    // Ensure picker starts on first available variant if possible
    if (variantPicker && addBtn) {
      if (firstAvailableVariant) {
        variantPicker.value = String(firstAvailableVariant.id);
        addBtn.setAttribute('data-product-id', String(firstAvailableVariant.id));
        syncButtonState(firstAvailableVariant.id);
      } else {
        // All sold out
        addBtn.setAttribute('data-product-id', String(initialVariantId));
        syncButtonState(initialVariantId);
      }

      // Update button data + enabled/disabled state when variant changes
      variantPicker.addEventListener('change', () => {
        addBtn.setAttribute('data-product-id', variantPicker.value);
        syncButtonState(variantPicker.value);
      });
    } else {
      // Single variant or no picker
      syncButtonState(initialVariantId);
    }

    // Plus / remove handler
    addBtn.addEventListener('click', (event) => {
      const selectedVariantId = parseInt(addBtn.getAttribute('data-product-id'), 10);
      const existingIndex = this.state.selectedItems.findIndex(item => item.id === selectedVariantId);

      // If already selected, allow remove even if sold out
      if (existingIndex > -1) {
        this.toggleItem({ 
          id: selectedVariantId, 
          shopifyProductId: product.shopifyProductId || product.id 
        }, event);
        return;
      }

      // If disabled (sold out), do nothing (defensive)
      if (addBtn.disabled) return;

      // Resolve selected variant object
      let selectedVariant = null;
      if (hasVariants) {
        selectedVariant = variants.find(v => v.id === selectedVariantId) || firstAvailableVariant || variants[0];
      } else {
        selectedVariant = product;
      }

      // Hard stop if unavailable
      if (selectedVariant && selectedVariant.available === false) {
        alert('Sorry, this item is sold out.');
        syncButtonState(selectedVariantId);
        return;
      }

      this.toggleItem({
        ...product,
        id: selectedVariantId,
        shopifyProductId: product.shopifyProductId || product.id, // Store original Shopify product ID
        price: parseFloat(selectedVariant.price),
        selectedVariantId: selectedVariantId,
        selectedVariantObj: selectedVariant,
        selectedVariantTitle: selectedVariant.title,
        variants: variants
      }, event);
    });

    // Inline fetch to get description (since it's not in your product object)
    const descEl = card.querySelector('[data-desc]');
    if (descEl && product.handle) {
      fetch(`/products/${product.handle}.js`)
        .then(r => r.ok ? r.json() : Promise.reject(r))
        .then(p => {
          const raw = p.body_html || p.description || '';
          if (!raw) { descEl.remove(); return; }
          const tmp = document.createElement('div');
          tmp.innerHTML = raw;
          const plain = (tmp.textContent || tmp.innerText || '').trim();
          if (!plain) { descEl.remove(); return; }
          const excerpt = plain.length > 50 ? plain.slice(0, 50) + '…' : plain;
          descEl.textContent = excerpt;
          descEl.style.display = '';
        })
        .catch(() => { if (descEl) descEl.remove(); });
    }

    return card;
  },

  // Toggle item selection
  toggleItem(product, event) {
    console.log('Toggling item:', product);

    const addBtn = event?.currentTarget;
    const buttonProductId = addBtn ? parseInt(addBtn.getAttribute('data-product-id')) : product.id;

    const existingIndex = this.state.selectedItems.findIndex(item => item.id === product.id);

    // Defensive: block adding sold-out variants (but allow removing if already selected)
    if (existingIndex === -1 && product?.selectedVariantObj && product.selectedVariantObj.available === false) {
      alert('Sorry, this item is sold out.');
      return;
    }

    if (existingIndex > -1) {
      // Remove item
      this.state.selectedItems.splice(existingIndex, 1);
    } else {
      // Add animation to button
      if (addBtn) {
        addBtn.classList.add('adding');
        setTimeout(() => addBtn.classList.remove('adding'), 500);
      }

      // Add item with quantity 1
      this.state.selectedItems.push({
        ...product,
        quantity: 1,
        isNew: true,
        shopifyProductId: product.shopifyProductId || product.id, // Store Shopify product ID explicitly
        selectedVariantId: product.selectedVariantId,
        selectedVariantObj: product.selectedVariantObj,
        selectedVariantTitle: product.selectedVariantTitle
      });

    }

    // Update UI
    this.updateSidebarItems();
    this.updateContinueButton();
    this.updateStickyBars();

    setTimeout(() => {
      console.log('Updating buttons for button product id:', buttonProductId);
      this.updateButtons(buttonProductId);
    }, 200);

    this.saveProgress();
    if (this.state.currentStep === 5 || this.state.selectedThemedCard) {
      this.refreshThemedCardUpgradeVisibility();
    }
  },

  // UPDATED: updateButtons - update all matching buttons for a given variant id
  updateButtons(id) {
    const buttons = this.elements.itemsGrid.querySelectorAll(`.add-item-btn[data-product-id="${id}"]`);
    const isSelected = this.state.selectedItems.some(item => item.id === id);

    buttons.forEach(btn => {
      if (isSelected) {
        btn.classList.add('remove-item-btn');
        btn.innerHTML = '✕';
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
      } else {
        btn.classList.remove('remove-item-btn');
        btn.innerHTML = '+';
        // Do not force-enable here because the variant might be sold out;
        // createProductCard/variantPicker logic handles disabled state.
      }
    });
  },

  // Update add/remove buttons (bulk)
  updateItemButtons() {
    const buttons = this.elements.itemsGrid.querySelectorAll('.add-item-btn');

    buttons.forEach(btn => {
      const productId = parseInt(btn.getAttribute('data-product-id'));
      const isSelected = this.state.selectedItems.some(item => item.id === productId);

      if (isSelected) {
        btn.classList.add('remove-item-btn');
        btn.innerHTML = '✕';
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
      } else {
        btn.classList.remove('remove-item-btn');
        btn.innerHTML = '+';
      }
    });
  },

  // Sync box selection UI
  syncBoxSelectionUI() {
    // Remove 'selected' from all box options
    this.elements.boxOptions.forEach(box => box.classList.remove('selected'));

    if (this.state.selectedBox) {
      // Find the box-option that matches the selectedBox type
      this.elements.boxOptions.forEach(box => {
        const boxType = box.getAttribute('data-box-type');
        if (boxType === this.state.selectedBox.type) {
          box.classList.add('selected');
          this.elements.continueToItems.disabled = false;
          // If it's a wicker basket, also set the color select
          if (boxType === 'wicker-basket' && this.state.selectedBox.color) {
            const colorSelect = box.querySelector('.box-color');
            if (colorSelect) {
              colorSelect.value = this.state.selectedBox.color;
            }
          }
        }
      });
    }
  },

  // Update pagination
  updatePagination() {
    const totalPages = Math.ceil(this.state.filteredProducts.length / this.state.itemsPerPage);

    this.elements.itemsPagination.innerHTML = '';

    if (totalPages <= 1) {
      this.elements.itemsPagination.style.display = 'none';
      return;
    }

    this.elements.itemsPagination.style.display = 'flex';

    // Previous button
    const prevBtn = document.createElement('button');
    prevBtn.className = 'pagination__button pagination__button--prev';
    prevBtn.innerHTML = '<span class="svg-wrapper">‹</span>';
    prevBtn.disabled = this.state.currentPage === 1;
    prevBtn.addEventListener('click', () => this.goToPage(this.state.currentPage - 1));
    this.elements.itemsPagination.appendChild(prevBtn);

    // Page numbers
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= this.state.currentPage - 2 && i <= this.state.currentPage + 2)) {
        const pageItem = document.createElement('li');
        pageItem.className = `pagination__item ${i === this.state.currentPage ? 'pagination__item--current' : ''}`;
        pageItem.textContent = i;
        pageItem.addEventListener('click', () => this.goToPage(i));
        this.elements.itemsPagination.appendChild(pageItem);
      } else if (i === this.state.currentPage - 3 || i === this.state.currentPage + 3) {
        const ellipsis = document.createElement('li');
        ellipsis.className = 'pagination__ellipsis';
        ellipsis.textContent = '...';
        this.elements.itemsPagination.appendChild(ellipsis);
      }
    }

    // Next button
    const nextBtn = document.createElement('button');
    nextBtn.className = 'pagination__button pagination__button--next';
    nextBtn.innerHTML = '<span class="svg-wrapper">›</span>';
    nextBtn.disabled = this.state.currentPage === totalPages;
    nextBtn.addEventListener('click', () => this.goToPage(this.state.currentPage + 1));
    this.elements.itemsPagination.appendChild(nextBtn);
  },

  // Go to page
  goToPage(page) {
    this.state.currentPage = page;
    this.displayProducts();

    // Scroll to top of grid
    this.elements.itemsGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  },

  openSidebar() {
    this.elements.hamperSidebar.classList.add('active');

    // On mobile, show overlay and prevent body scroll
    if (window.innerWidth < 750) {
      // Create overlay if it doesn't exist
      if (!this.elements.hamperSidebarOverlay) {
        const overlay = document.createElement('div');
        overlay.className = 'hamper-sidebar-overlay';
        overlay.id = 'hamper-sidebar-overlay';
        document.body.appendChild(overlay);
        this.elements.hamperSidebarOverlay = overlay;

        // Add click handler
        overlay.addEventListener('click', () => this.closeSidebar());
      }

      this.elements.hamperSidebarOverlay.classList.add('active');
      document.body.classList.add('hamper-sidebar-open');
    }

    // Update sticky bars when sidebar opens
    setTimeout(() => {
      this.updateStickyBars();
    }, 350);
  },

  closeSidebar() {
    this.elements.hamperSidebar.classList.remove('active');

    // On mobile, hide overlay and restore body scroll
    if (this.elements.hamperSidebarOverlay) {
      this.elements.hamperSidebarOverlay.classList.remove('active');
    }
    document.body.classList.remove('hamper-sidebar-open');

    // Update sticky bars when sidebar closes
    setTimeout(() => {
      this.updateStickyBars();
    }, 350);
  },

  // Update sidebar box info
  updateSidebarBox() {
    if (this.state.selectedBox) {
      let boxName = this.state.selectedBox.name;
      if (this.state.selectedBox.color) {
        boxName += ` (${this.state.selectedBox.color.charAt(0).toUpperCase() + this.state.selectedBox.color.slice(1)})`;
      }
      this.elements.sidebarBoxName.textContent = boxName;
    } else {
      this.elements.sidebarBoxName.textContent = 'No box selected';
    }

    this.updateTotal();
    this.updateSummarySection();
  },

  // Update sidebar items
  updateSidebarItems() {
    this.elements.sidebarItemsList.innerHTML = '';

    this.state.selectedItems.forEach(item => {
      const itemEl = document.createElement('div');
      itemEl.className = 'hamper-sidebar-item';

      // Add animation class for new items
      if (item.isNew) {
        itemEl.classList.add('new-item');
        // Remove flag after animation
        setTimeout(() => {
          item.isNew = false;
        }, 800);
      }

      itemEl.innerHTML = `
        <div class="hamper-sidebar-item-image">
          <img src="${item.images && item.images[0]?.src ? item.images[0].src : ''}" alt="${item.title || ''}">
        </div>
        <div class="hamper-sidebar-item-content">
          <div class="hamper-sidebar-item-title">${item.title || ''}</div>
          <div class="hamper-sidebar-item-price">£${(item.price || 0).toFixed(2)}</div>
          <div class="hamper-sidebar-item-actions">
            <div class="quantity-selector">
              <button class="quantity-btn minus" data-product-id="${item.selectedVariantId || item.id}">−</button>
              <span class="quantity-value">${item.quantity}</span>
              <button class="quantity-btn plus" data-product-id="${item.selectedVariantId || item.id}">+</button>
            </div>
            <button class="remove-item" data-product-id="${item.selectedVariantId || item.id}">✕</button>
          </div>
        </div>
      `;

      // Add event listeners
      const minusBtn = itemEl.querySelector('.minus');
      const plusBtn = itemEl.querySelector('.plus');
      const removeBtn = itemEl.querySelector('.remove-item');

      minusBtn.addEventListener('click', () => this.updateQuantity(item.id, -1));
      plusBtn.addEventListener('click', () => this.updateQuantity(item.id, 1));
      removeBtn.addEventListener('click', () => this.removeItem(item.id));

      this.elements.sidebarItemsList.appendChild(itemEl);
    });

    // Update count with animation
    const totalItems = this.state.selectedItems.reduce((sum, item) => sum + item.quantity, 0);
    const countElement = this.elements.sidebarItemsCount;
    const newCount = `(${totalItems} items)`;

    if (countElement.textContent !== newCount) {
      countElement.style.transition = 'none';
      countElement.style.transform = 'scale(1.2)';
      countElement.textContent = newCount;

      setTimeout(() => {
        countElement.style.transition = 'transform 0.3s';
        countElement.style.transform = 'scale(1)';
      }, 50);
    }

    this.updateTotal();
    this.updateSummarySection();
    this.updateStickyBars();
  },

  // Update item quantity
  updateQuantity(productId, change) {
    const item = this.state.selectedItems.find(i => i.id === productId);
    if (item) {
      item.quantity = Math.max(1, item.quantity + change);
      this.updateSidebarItems();
      this.saveProgress();
      if (this.state.currentStep === 5) {
        this.refreshThemedCardUpgradeVisibility();
      }
    }
  },

  // Remove item
  removeItem(productId) {
    this.state.selectedItems = this.state.selectedItems.filter(item => item.id !== productId);
    this.updateItemButtons();
    this.updateSidebarItems();
    this.updateContinueButton();
    this.saveProgress();
    if (this.state.currentStep === 5 || this.state.selectedThemedCard) {
      this.refreshThemedCardUpgradeVisibility();
    }
  },

  // Update continue button state
  updateContinueButton() {
    if (this.elements.sidebarContinue) {
      this.elements.sidebarContinue.disabled = this.state.selectedItems.length === 0;
    }

    // Update mobile and desktop sticky bar buttons
    if (this.elements.mobileContinueBtn) {
      this.elements.mobileContinueBtn.disabled = this.state.selectedItems.length === 0;
    }
    if (this.elements.desktopContinueBtn) {
      this.elements.desktopContinueBtn.disabled = this.state.selectedItems.length === 0;
    }
  },

  // Update total price
  updateTotal() {
    let total = 0;

    // Box price
    if (this.state.selectedBox) {
      total += this.state.selectedBox.price;
    }

    // Items price
    this.state.selectedItems.forEach(item => {
      total += item.price * item.quantity;
    });

    // Box personalisation price
    if (this.state.messaging.boxPersonalisation) {
      const option = this.elements.boxPersonalisation.querySelector(`option[value="${this.state.messaging.boxPersonalisation}"]`);
      if (option) {
        total += parseFloat(option.getAttribute('data-price') || 0);
      }
    }

    // Personalisation price
    Object.values(this.state.personalisations).forEach(personalisation => {
      total += personalisation.price || 0;
    });

    // Logo personalisation is currently free; keep the calculation path for future pricing.
    Object.keys(this.state.logoPersonalisations).forEach(() => {
      total += this.LOGO_PERSONALISATION_PRICE;
    });

    total += this.getGiftWrapAdditionalTotal();
    total += this.getSelectedThemedCardPrice();

    // Update main hamper total price (sidebar)
    if (this.elements.hamperTotalPrice) {
      this.elements.hamperTotalPrice.textContent = `£${total.toFixed(2)}`;
    }

    // Update summary total price
    if (this.elements.summaryTotalPrice) {
      this.elements.summaryTotalPrice.textContent = `£${total.toFixed(2)}`;
    }

    // Update mobile and desktop sticky bar totals
    if (this.elements.mobileTotalPrice) {
      this.elements.mobileTotalPrice.textContent = `£${total.toFixed(2)}`;
    }
    if (this.elements.desktopTotalPrice) {
      this.elements.desktopTotalPrice.textContent = `£${total.toFixed(2)}`;
    }
  },

  // Update sticky bars
  updateStickyBars() {
    if (this.state.currentStep !== 2) return;

    const totalItems = this.state.selectedItems.reduce((sum, item) => sum + item.quantity, 0);
    const itemsText = `${totalItems} Items Selected`;

    // Update mobile sticky bar
    if (this.elements.mobileStickyBar && window.innerWidth < 750) {
      this.elements.mobileStickyBar.style.display = 'block';
      if (this.elements.mobileItemsCount) {
        this.elements.mobileItemsCount.textContent = itemsText;
      }
    }

    // Update desktop sticky bar
    if (this.elements.desktopStickyBar && window.innerWidth >= 750) {
      // Check if sidebar exists and is active
      const sidebarActive = this.elements.hamperSidebar && this.elements.hamperSidebar.classList.contains('active');

      // Show desktop sticky bar when sidebar is NOT active (closed) and there are items
      if (!sidebarActive && totalItems > 0) {
        this.elements.desktopStickyBar.classList.add('show');
      } else {
        this.elements.desktopStickyBar.classList.remove('show');
      }

      if (this.elements.desktopItemsCount) {
        this.elements.desktopItemsCount.textContent = itemsText;
      }
    }

    this.updateTotal();
    this.updateContinueButton();
  },

  // Setup personalisation step
  setupPersonalisation() {
    this.elements.personalisationItems.innerHTML = '';

    // Get personalisable items
    const personalisableItems = this.state.selectedItems.filter(item => item.canPersonalise);

    if (personalisableItems.length === 0) {
      this.elements.personalisationItems.innerHTML = '<div class="no-personalisation-message">You have selected no items that can be personalised, please proceed to messaging</div>';
      return;
    }

    // Add info text
    const info = document.createElement('p');
    info.textContent = 'You have selected items that can be personalised, please provide details here for each item';
    this.elements.personalisationItems.appendChild(info);

    // Create personalisation options for each item
    personalisableItems.forEach(item => {
      // Account for quantity - create personalisation for each
      for (let i = 0; i < item.quantity; i++) {
        const itemEl = document.createElement('div');
        itemEl.className = 'personalisation-item';
        // Use shopifyProductId for consistent matching
        const shopifyProductId = item.shopifyProductId || item.id;
        const itemKey = `${shopifyProductId}_${i}`;
        
        console.log('🔧 Setup personalisation for:', item.title, 'Key:', itemKey, 'Shopify Product ID:', shopifyProductId);

        // Get personalisation type for this item
        const personalisationTypes = this.getPersonalisationTypes(item.tags || []);
        const personalisationType = personalisationTypes[0] || item.personalisationType;
        const canPersonaliseLogo = item.canPersonaliseLogo || (item.tags || []).some(tag => ['personalise:logo', 'personalise:logo0'].includes(tag.toLowerCase()));
        if (!personalisationTypes.length && !canPersonaliseLogo) continue;

        itemEl.innerHTML = `
          <div class="personalisation-item-image">
            <img src="${item.images[0]?.src || ''}" alt="${item.title}">
          </div>
          <div class="personalisation-content">
            <h3 class="personalisation-title">${item.title}</h3>
            ${personalisationTypes.map(typeConfig => {
              const textKey = `${itemKey}__${typeConfig.key || typeConfig.type}`;
              return `
            <div class="personalisation-toggle">
              <span>${typeConfig.question}</span>
              <label class="toggle-switch">
                <input type="checkbox" data-item-key="${textKey}" data-base-item-key="${itemKey}" data-personalisation-kind="${typeConfig.key || typeConfig.type}" class="name-toggle">
                <span class="toggle-slider"></span>
              </label>
            </div>
            <div class="personalisation-options" data-item-key="${textKey}">
              <div class="personalisation-field">
                <label>${typeConfig.label}</label>
                <input type="text"
                       placeholder="${typeConfig.placeholder}"
                       maxlength="${typeConfig.maxLength}"
                       data-item-key="${textKey}"
                       class="name-input">
                <span class="character-count"><span>0</span>/${typeConfig.maxLength}</span>
              </div>
            </div>
            `;
            }).join('')}
            ${canPersonaliseLogo ? `
            <div class="personalisation-toggle" style="margin-top: 1rem;">
              <span>Would you like this item personalised with your logo?</span>
              <label class="toggle-switch">
                <input type="checkbox" data-item-key="${itemKey}" class="logo-toggle">
                <span class="toggle-slider"></span>
              </label>
            </div>
            <div class="personalisation-options logo-options" data-item-key="${itemKey}" style="display: none;">
              <div class="personalisation-field">
                <label>Upload Logo (+£0.00)</label>
                <input type="file" accept="image/*" data-item-key="${itemKey}" class="logo-upload" style="margin-bottom: 0.5rem;">
                <div class="logo-preview" data-item-key="${itemKey}"></div>
              </div>
            </div>
            ` : ''}
          </div>
        `;

        // Add event listeners for text personalisation options
        itemEl.querySelectorAll('.name-toggle').forEach((nameToggle) => {
          const textKey = nameToggle.getAttribute('data-item-key');
          const kind = nameToggle.getAttribute('data-personalisation-kind');
          const typeConfig = personalisationTypes.find(type => String(type.key || type.type) === String(kind));
          if (!textKey || !typeConfig) return;

          const nameOptions = itemEl.querySelector('.personalisation-options[data-item-key="' + textKey + '"]');
          const nameInput = itemEl.querySelector('.name-input[data-item-key="' + textKey + '"]');
          const charCount = nameOptions ? nameOptions.querySelector('.character-count span') : null;

          if (!nameOptions || !nameInput || !charCount) return;

          if (this.state.personalisations[textKey]) {
            nameToggle.checked = true;
            nameOptions.classList.add('active');
            nameInput.value = this.state.personalisations[textKey].value;
            charCount.textContent = nameInput.value.length;
          }

          nameToggle.addEventListener('change', (e) => {
            nameOptions.classList.toggle('active', e.target.checked);

            if (!e.target.checked) {
              delete this.state.personalisations[textKey];
              nameInput.value = '';
              charCount.textContent = '0';
            } else if (nameInput.value.trim()) {
              this.state.personalisations[textKey] = {
                shopifyProductId: item.shopifyProductId || item.id,
                variantId: item.selectedVariantId || item.id,
                type: typeConfig.type,
                key: typeConfig.key || typeConfig.type,
                label: typeConfig.label,
                value: nameInput.value.trim(),
                price: typeConfig.price
              };
            }
            this.updateTotal();
          });

          nameInput.addEventListener('input', (e) => {
            charCount.textContent = e.target.value.length;

            if (nameToggle.checked && e.target.value.trim()) {
              this.state.personalisations[textKey] = {
                shopifyProductId: item.shopifyProductId || item.id,
                variantId: item.selectedVariantId || item.id,
                type: typeConfig.type,
                key: typeConfig.key || typeConfig.type,
                label: typeConfig.label,
                value: e.target.value.trim(),
                price: typeConfig.price
              };
              console.log('💾 Saved personalisation:', textKey, '=', e.target.value, 'Price:', typeConfig.price);
            } else {
              delete this.state.personalisations[textKey];
            }

            this.updateTotal();
          });
        });

        // Add event listeners for logo personalization (only present when canPersonaliseLogo)
        const logoToggle = itemEl.querySelector('.logo-toggle');
        const logoOptions = itemEl.querySelector('.logo-options');
        const logoUpload = itemEl.querySelector('.logo-upload');
        const logoPreview = itemEl.querySelector('.logo-preview');

        // Check if already personalised with logo
        if (logoToggle && this.state.logoPersonalisations[itemKey]) {
          logoToggle.checked = true;
          logoOptions.style.display = 'block';
          this.restoreLogoPreview(logoPreview, itemKey);
        }

        if (logoToggle) {
          // Logo toggle event
          logoToggle.addEventListener('change', (e) => {
            logoOptions.style.display = e.target.checked ? 'block' : 'none';

            if (!e.target.checked) {
              delete this.state.logoPersonalisations[itemKey];
              logoUpload.value = '';
              logoPreview.innerHTML = '';
            }
            this.updateTotal();
          });

          // Logo upload event
          logoUpload.addEventListener('change', (e) => {
            this.handleLogoUpload(e, itemKey, item, logoPreview);
          });
        }

        this.elements.personalisationItems.appendChild(itemEl);
      }
    });
  },

  // Handle logo upload to Cloudinary
  handleLogoUpload(e, itemKey, item, previewEl) {
    const input = e.target;
    const file = input && input.files && input.files[0];

    const clearPreview = () => {
      if (previewEl) previewEl.innerHTML = '';
      delete this.state.logoPersonalisations[itemKey];
    };

    if (!file) {
      clearPreview();
      this.updateTotal();
      return;
    }

    if (!file.type || !file.type.startsWith('image/')) {
      if (previewEl) {
        previewEl.innerHTML = `<div style="color:#d00;">Please upload an image file (PNG, JPG, SVG).</div>`;
      }
      input.value = '';
      clearPreview();
      return;
    }

    // Show loading
    if (previewEl) {
      previewEl.innerHTML = `<div style="color:#888;">Uploading logo...</div>`;
    }

    // Cloudinary upload
    const cloudName = 'da5cktdv2';
    const uploadPreset = 'tophampers';

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', uploadPreset);

    fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(data => {
      console.log('Cloudinary response:', data);
      if (data.secure_url) {
        // Store logo data
        this.state.logoPersonalisations[itemKey] = {
          shopifyProductId: item.shopifyProductId || item.id,
          variantId: item.selectedVariantId || item.id,
          logoUrl: data.secure_url,
          logoFilename: file.name,
          itemTitle: item.title
        };

        console.log('💾 Saved logo personalisation:', itemKey, '=', data.secure_url);

        // Show preview
        if (previewEl) {
          previewEl.innerHTML = `
            <div style="display:flex;gap:.5rem;align-items:center;margin-top:0.5rem;">
              <div style="flex:1;">
                <img src="${data.secure_url}" alt="Logo preview" style="max-width:100%;max-height:100px;object-fit:contain;border:1px solid #eee;padding:6px;border-radius:6px;">
              </div>
              <div style="flex:0 0 auto;">
                <button type="button" class="btn-remove-logo" data-item-key="${itemKey}" style="background:#fff;border:1px solid #ddd;padding:.4rem .6rem;border-radius:6px;cursor:pointer;">Remove</button>
              </div>
            </div>
          `;
          
          const removeBtn = previewEl.querySelector('.btn-remove-logo');
          if (removeBtn) {
            removeBtn.addEventListener('click', () => {
              input.value = '';
              clearPreview();
              this.updateTotal();
            });
          }
        }

        this.updateTotal();
      } else {
        console.error('Cloudinary upload failed:', data);
        if (previewEl) {
          previewEl.innerHTML = `<div style="color:#d00;">Logo upload failed. Please try again.</div>`;
        }
        input.value = '';
        clearPreview();
      }
    })
    .catch(err => {
      console.error('Cloudinary upload error:', err);
      if (previewEl) {
        previewEl.innerHTML = `<div style="color:#d00;">Logo upload failed. Please try again.</div>`;
      }
      input.value = '';
      clearPreview();
    });
  },

  // Restore logo preview from state
  restoreLogoPreview(previewEl, itemKey) {
    const logoData = this.state.logoPersonalisations[itemKey];
    if (!logoData || !previewEl) return;

    previewEl.innerHTML = `
      <div style="display:flex;gap:.5rem;align-items:center;margin-top:0.5rem;">
        <div style="flex:1;">
          <img src="${logoData.logoUrl}" alt="Logo preview" style="max-width:100%;max-height:100px;object-fit:contain;border:1px solid #eee;padding:6px;border-radius:6px;">
        </div>
        <div style="flex:0 0 auto;">
          <button type="button" class="btn-remove-logo" data-item-key="${itemKey}" style="background:#fff;border:1px solid #ddd;padding:.4rem .6rem;border-radius:6px;cursor:pointer;">Remove</button>
        </div>
      </div>
    `;
    
    const removeBtn = previewEl.querySelector('.btn-remove-logo');
    if (removeBtn) {
      removeBtn.addEventListener('click', () => {
        const logoUpload = document.querySelector(`.logo-upload[data-item-key="${itemKey}"]`);
        if (logoUpload) logoUpload.value = '';
        previewEl.innerHTML = '';
        delete this.state.logoPersonalisations[itemKey];
        this.updateTotal();
      });
    }
  },

  escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }[char]));
  },

  formatCurrency(value) {
    return `\u00a3${(Number(value) || 0).toFixed(2)}`;
  },

  extractImageUrl(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    if (image.src) return image.src;
    if (image.url) return image.url;
    if (image.preview_image) return this.extractImageUrl(image.preview_image);
    if (image.featured_image) return this.extractImageUrl(image.featured_image);
    return '';
  },

  getSelectedThemedCardPrice() {
    const card = this.state.selectedThemedCard;
    return card ? Number(card.price) || 0 : 0;
  },

  async fetchThemeCardsForHandle(handle) {
    if (!handle) return [];
    try {
      const response = await fetch(`/products/${encodeURIComponent(handle)}?view=card-json`);
      if (!response.ok) return [];
      const data = await response.json();
      return Array.isArray(data.cards) ? data.cards.filter(card => card && card.variantId) : [];
    } catch (error) {
      console.warn('Could not load themed cards for product:', handle, error);
      return [];
    }
  },

  getThemedCardCollectionHandles() {
    return ['food-drink-cards', 'food-drink-hampers-cards', 'food-and-drink-hampers-cards'];
  },

  normalizeThemedCardProduct(product) {
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    const variant = variants.find(item => item && item.available !== false && item.id) || variants.find(item => item && item.id);
    if (!product || !variant || !variant.id) return null;

    const image = this.extractImageUrl(product.image || (Array.isArray(product.images) ? product.images[0] : ''));
    const price = Number.parseFloat(variant.price || product.price || 0) || 0;

    return {
      id: product.id,
      variantId: variant.id,
      title: product.title || variant.title || 'Themed Card',
      price,
      image,
      url: product.handle ? `/products/${product.handle}` : ''
    };
  },

  async fetchThemedCardsCollection(handle) {
    if (!handle) return [];
    try {
      const response = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250`);
      if (!response.ok) return [];
      const data = await response.json();
      const products = Array.isArray(data.products) ? data.products : [];
      return products.map(product => this.normalizeThemedCardProduct(product)).filter(Boolean);
    } catch (error) {
      console.warn('Could not load themed card collection:', handle, error);
      return [];
    }
  },

  async getAvailableThemedCards() {
    const cardsByVariant = new Map();
    const handles = this.getThemedCardCollectionHandles();

    for (const handle of handles) {
      const cards = await this.fetchThemedCardsCollection(handle);
      cards.forEach(card => {
        const key = String(card.variantId || card.id || card.title);
        if (!cardsByVariant.has(key)) cardsByVariant.set(key, card);
      });

      if (cardsByVariant.size) break;
    }

    return [...cardsByVariant.values()];
  },

  async refreshThemedCardUpgradeVisibility() {
    const row = this.elements.themedCardUpgrade || document.getElementById('byo-themed-card-upgrade');
    const toggle = this.elements.themedCardToggle || document.getElementById('gift-card-toggle');
    if (!row) return false;

    const refreshToken = (this.themedCardRefreshToken || 0) + 1;
    this.themedCardRefreshToken = refreshToken;
    row.style.display = 'none';

    const cards = await this.getAvailableThemedCards();
    if (refreshToken !== this.themedCardRefreshToken) return false;

    const hasCards = cards.length > 0;
    row.style.display = hasCards ? '' : 'none';

    if (!hasCards) {
      if (toggle) toggle.checked = false;
      if (this.state.selectedThemedCard) {
        this.clearThemedCardSelection();
      }
    }

    return hasCards;
  },

  renderThemedCards(cards) {
    const wrapper = this.elements.weddingCardsWrapper || document.querySelector('.wedding-cards-swiper .swiper-wrapper');
    const addButton = this.elements.addWeddingCardBtn || document.getElementById('add-wedding-card-to-cart');
    if (!wrapper) return;

    if (!cards.length) {
      wrapper.innerHTML = '<div class="swiper-slide themed-card-empty" style="width:100%;cursor:default;text-align:center;padding:32px;">No themed cards are assigned to the selected products.</div>';
      if (addButton) addButton.classList.add('disabled_btn');
      return;
    }

    wrapper.innerHTML = cards.map(card => `
      <div class="swiper-slide"
        variant-id="${this.escapeHTML(card.variantId)}"
        data-title="${this.escapeHTML(card.title)}"
        data-price="${Number(card.price) || 0}"
        data-image="${this.escapeHTML(card.image || '')}"
        style="display:flex;flex-direction:column;align-items:center;">
        <div class="card">
          <div class="card-image">
            ${card.image ? `<img src="${this.escapeHTML(card.image)}" alt="${this.escapeHTML(card.title)}" style="width:100%;height:100%;object-fit:cover;">` : ''}
          </div>
          <div style="margin-top:16px;text-align:center;">
            <div class="card-title">${this.escapeHTML(card.title)}</div>
          </div>
        </div>
      </div>
    `).join('');

    if (addButton) addButton.classList.add('disabled_btn');
    wrapper.querySelectorAll('.swiper-slide').forEach(slide => {
      slide.addEventListener('click', () => {
        wrapper.querySelectorAll('.swiper-slide').forEach(item => item.classList.remove('card-active'));
        slide.classList.add('card-active');
        if (addButton) addButton.classList.remove('disabled_btn');
      });
    });

    if (this.themedCardSwiper && typeof this.themedCardSwiper.destroy === 'function') {
      this.themedCardSwiper.destroy(true, true);
      this.themedCardSwiper = null;
    }
    if (window.Swiper) {
      this.themedCardSwiper = new Swiper('.wedding-cards-swiper', {
        slidesPerView: 4,
        spaceBetween: 16,
        navigation: { nextEl: '.card-button-next', prevEl: '.card-button-prev' },
        pagination: { el: '.cards-fraction', type: 'fraction' },
        breakpoints: {
          0: { slidesPerView: 1.5 },
          640: { slidesPerView: 2 },
          990: { slidesPerView: 4 }
        }
      });
    }
  },

  async openThemedCardPopup() {
    const overlay = this.elements.weddingCardsOverlay || document.getElementById('wedding-cards-popup-overlay');
    if (!overlay) return;
    const cards = await this.getAvailableThemedCards();
    if (!cards.length) {
      const toggle = this.elements.themedCardToggle || document.getElementById('gift-card-toggle');
      if (toggle) toggle.checked = false;
      const row = this.elements.themedCardUpgrade || document.getElementById('byo-themed-card-upgrade');
      if (row) row.style.display = 'none';
      this.clearThemedCardSelection();
      return;
    }
    this.renderThemedCards(cards);
    overlay.style.display = 'flex';
  },

  clearThemedCardSelection() {
    this.state.selectedThemedCard = null;
    const widget = this.elements.selectedCardWidget || document.getElementById('selected-card-widget');
    if (widget) {
      widget.style.display = 'none';
      widget.innerHTML = '';
    }
    const priceEl = this.elements.themedCardPrice || document.getElementById('byo-themed-card-price');
    if (priceEl) priceEl.textContent = '+£3.00';
    document.querySelectorAll('.wedding-cards-swiper .swiper-slide.card-active').forEach(slide => slide.classList.remove('card-active'));
    this.updateTotal();
    this.updateSummaryTotal();
    this.saveProgress();
  },

  setSelectedThemedCardFromSlide(slide) {
    if (!slide) return;
    const card = {
      variantId: slide.getAttribute('variant-id'),
      title: slide.getAttribute('data-title') || '',
      price: Number(slide.getAttribute('data-price')) || 0,
      image: slide.getAttribute('data-image') || ''
    };
    this.state.selectedThemedCard = card;
    this.updateSelectedThemedCardWidget();
    this.updateTotal();
    this.updateSummaryTotal();
    this.saveProgress();
  },

  updateSelectedThemedCardWidget() {
    const card = this.state.selectedThemedCard;
    const widget = this.elements.selectedCardWidget || document.getElementById('selected-card-widget');
    const priceEl = this.elements.themedCardPrice || document.getElementById('byo-themed-card-price');
    const toggle = this.elements.themedCardToggle || document.getElementById('gift-card-toggle');

    if (!card) {
      if (widget) {
        widget.style.display = 'none';
        widget.innerHTML = '';
      }
      if (priceEl) priceEl.textContent = '+£3.00';
      if (toggle) toggle.checked = false;
      return;
    }

    if (priceEl) priceEl.textContent = `+£${(Number(card.price) || 0).toFixed(2)}`;
    if (toggle) toggle.checked = true;
    if (widget) {
      widget.style.display = 'block';
      widget.innerHTML = `
        <div class="selected-card-widget-inner" style="display:flex;gap:12px;align-items:center;">
          ${card.image ? `<img src="${this.escapeHTML(card.image)}" alt="${this.escapeHTML(card.title)}" style="width:56px;height:56px;object-fit:cover;border-radius:12px 0 0 0;">` : ''}
          <div class="selected-card-title">${this.escapeHTML(card.title)}</div>
          <button type="button" class="edit-card-btn" id="edit-themed-card-selection">Edit</button>
        </div>
      `;
      const editBtn = widget.querySelector('#edit-themed-card-selection');
      if (editBtn) editBtn.addEventListener('click', () => this.openThemedCardPopup());
    }
  },

  setupThemedCardUpgrade() {
    const toggle = this.elements.themedCardToggle || document.getElementById('gift-card-toggle');
    const overlay = this.elements.weddingCardsOverlay || document.getElementById('wedding-cards-popup-overlay');
    const closeBtn = this.elements.weddingCardsClose || document.getElementById('close-wedding-cards-popup');
    const addButton = this.elements.addWeddingCardBtn || document.getElementById('add-wedding-card-to-cart');

    if (toggle) {
      toggle.addEventListener('change', async (event) => {
        if (event.target.checked) {
          await this.openThemedCardPopup();
        } else {
          this.clearThemedCardSelection();
        }
      });
    }

    if (closeBtn && overlay) {
      closeBtn.addEventListener('click', () => {
        overlay.style.display = 'none';
        if (!this.state.selectedThemedCard && toggle) toggle.checked = false;
      });
    }

    if (overlay) {
      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) {
          overlay.style.display = 'none';
          if (!this.state.selectedThemedCard && toggle) toggle.checked = false;
        }
      });
    }

    if (addButton) {
      addButton.addEventListener('click', () => {
        if (addButton.classList.contains('disabled_btn')) return;
        const activeSlide = document.querySelector('.wedding-cards-swiper .swiper-slide.card-active');
        this.setSelectedThemedCardFromSlide(activeSlide);
        if (overlay) overlay.style.display = 'none';
      });
    }

    this.updateSelectedThemedCardWidget();
  },

  getGiftWrapConfig() {
    const fallbackPapers = [
      { key: 'gold', label: 'Gold', price: 2.5, image: '', variantId: null },
      { key: 'white', label: 'White', price: 2.5, image: '', variantId: null },
      { key: 'black', label: 'Black', price: 2.5, image: '', variantId: null },
      { key: 'blue-stripes', label: 'Blue Stripes', price: 2.5, image: '', variantId: null },
      { key: 'pink-hearts', label: 'Pink Hearts', price: 2.5, image: '', variantId: null },
      { key: 'gold-2', label: 'Gold', price: 2.5, image: '', variantId: null },
      { key: 'white-2', label: 'White', price: 2.5, image: '', variantId: null },
      { key: 'black-2', label: 'Black', price: 2.5, image: '', variantId: null },
      { key: 'blue-stripes-2', label: 'Blue Stripes', price: 2.5, image: '', variantId: null },
      { key: 'pink-hearts-2', label: 'Pink Hearts', price: 2.5, image: '', variantId: null }
    ];
    const config = window.giftWrapConfig || {};
    const paperProducts = Array.isArray(config.paperProducts) && config.paperProducts.length ? config.paperProducts : fallbackPapers;
    const fallbackIndividualWrapItems = [
      { key: 'occasions-plum', title: 'Occasions Plum and Honeysuckle Wonderful Mum Guest Soaps', price: 3, image: '', variantId: null },
      { key: 'hydrating-hand-mask', title: 'Hydrating Hand Mask Professional Hand Glove', price: 3, image: '', variantId: null },
      { key: 'vintage-leather-card-holder', title: 'Vintage Leather Card Holder In Brown', price: 3, image: '', variantId: null }
    ];
    const individualWrapItems = Array.isArray(config.individualWrapItems) && config.individualWrapItems.length
      ? config.individualWrapItems
      : fallbackIndividualWrapItems;

    return {
      itemWrapPrice: Number(config.itemWrapPrice) || 3,
      paperFallbackPrice: Number(config.paperFallbackPrice) || 2.5,
      penSellotapePrice: Number(config.penSellotapePrice) || 2,
      itemWrapVariantId: config.itemWrapVariantId || null,
      paperFallbackVariantId: config.paperFallbackVariantId || null,
      penSellotapeVariantId: config.penSellotapeVariantId || null,
      paperProducts,
      individualWrapItems
    };
  },

  getGiftWrapItemKey(item) {
    return String(item.giftWrapKey || item.selectedVariantId || (item.variants && item.variants[0] && item.variants[0].id) || item.shopifyProductId || item.id || item.title);
  },

  getGiftWrapItemImage(item) {
    if (item.images && item.images[0]) {
      return this.extractImageUrl(item.images[0]);
    }
    return this.extractImageUrl(item.featured_image);
  },

  setupGiftWrap() {
    if (!this.state.giftWrap) {
      this.state.giftWrap = { selfWrap: false, paperQuantities: {}, penSellotape: false, wrappedItems: {} };
    }
    this.renderGiftWrapPaperGrid();
    this.renderGiftWrapItems();
    this.syncGiftWrapUI();
  },

  getDefaultIndividualWrapItems() {
    return this.getGiftWrapConfig().individualWrapItems;
  },

  getDefaultIndividualWrapTitles() {
    return this.getDefaultIndividualWrapItems().map(item => item.title);
  },

  getGiftWrapItemPrice(item, config = this.getGiftWrapConfig()) {
    return Number(item.wrapPrice || item.price) || config.itemWrapPrice;
  },

  findGiftWrapProductByTitle(title) {
    const normalize = value => String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    const target = normalize(title);
    const pools = [
      this.state.selectedItems || [],
      this.state.allProducts || []
    ];

    for (const pool of pools) {
      const exact = pool.find(item => normalize(item.title) === target);
      if (exact) return exact;
      const partial = pool.find(item => {
        const itemTitle = normalize(item.title);
        return itemTitle.includes(target) || target.includes(itemTitle);
      });
      if (partial) return partial;
    }

    return null;
  },

  getIndividualWrapItems() {
    const config = this.getGiftWrapConfig();
    return this.getVisibleSelectedItems().map((item, index) => {
      const key = this.getGiftWrapItemKey(item) || `selected-gift-${index}`;
      return {
        ...item,
        id: key,
        giftWrapKey: key,
        title: item.title || `Selected gift ${index + 1}`,
        wrapPrice: config.itemWrapPrice,
        wrapVariantId: null,
        quantity: item.quantity || 1
      };
    });
  },

  renderGiftWrapPaperGrid() {
    if (!this.elements.giftWrapPaperGrid) return;
    const config = this.getGiftWrapConfig();
    this.elements.giftWrapPaperGrid.innerHTML = config.paperProducts.map(paper => {
      const qty = this.state.giftWrap.paperQuantities[paper.key] || 0;
      const imageUrl = this.extractImageUrl(paper.image);
      const image = imageUrl
        ? `<img src="${this.escapeHTML(imageUrl)}" alt="${this.escapeHTML(paper.label)}">`
        : '<span class="gift-wrap-paper-placeholder"></span>';
      return `
        <div class="gift-wrap-paper-card" data-paper-key="${this.escapeHTML(paper.key)}">
          <div class="gift-wrap-paper-image">${image}</div>
          <div class="gift-wrap-paper-name">${this.escapeHTML(paper.label)}</div>
            <div class="gift-wrap-paper-size">${this.escapeHTML(paper.size || '60mm x 60mm')}</div>
          <div class="gift-wrap-paper-controls">
            <span>${this.formatCurrency(paper.price || config.paperFallbackPrice)}</span>
            <div class="gift-wrap-quantity">
              <button type="button" class="gift-wrap-qty-btn minus" data-paper-key="${this.escapeHTML(paper.key)}" data-qty-action="decrease" aria-label="Remove ${this.escapeHTML(paper.label)} paper">-</button>
              <span class="gift-wrap-qty-value" data-paper-qty="${this.escapeHTML(paper.key)}">${qty}</span>
              <button type="button" class="gift-wrap-qty-btn plus" data-paper-key="${this.escapeHTML(paper.key)}" data-qty-action="increase" aria-label="Add ${this.escapeHTML(paper.label)} paper">+</button>
            </div>
          </div>
        </div>
      `;
    }).join('');

    this.elements.giftWrapPaperGrid.querySelectorAll('[data-qty-action]').forEach(button => {
      button.addEventListener('click', () => {
        const key = button.getAttribute('data-paper-key');
        const action = button.getAttribute('data-qty-action');
        const currentQty = this.state.giftWrap.paperQuantities[key] || 0;
        const nextQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
        this.state.giftWrap.paperQuantities[key] = nextQty;
        const qtyEl = this.elements.giftWrapPaperGrid.querySelector(`[data-paper-qty="${key}"]`);
        if (qtyEl) qtyEl.textContent = nextQty;
        this.updateTotal();
        this.saveProgress();
      });
    });
  },

  renderGiftWrapItems() {
    if (!this.elements.giftWrapItemsList) return;
    const giftWrapItems = this.getIndividualWrapItems();
    if (!giftWrapItems.length) {
      this.elements.giftWrapItemsList.innerHTML = '<div class="gift-wrap-empty">Choose items before selecting gift wrap.</div>';
      return;
    }

    const config = this.getGiftWrapConfig();
    this.elements.giftWrapItemsList.innerHTML = giftWrapItems.map(item => {
      const key = this.getGiftWrapItemKey(item);
      const image = this.getGiftWrapItemImage(item);
      const itemPrice = this.getGiftWrapItemPrice(item, config);
      const title = item.quantity > 1 ? `${item.title} x ${item.quantity}` : item.title;
      return `
        <div class="gift-wrap-item-row">
          <div class="gift-wrap-item-image">${image ? `<img src="${this.escapeHTML(image)}" alt="${this.escapeHTML(item.title)}">` : ''}</div>
          <div class="gift-wrap-item-title">${this.escapeHTML(title)}</div>
          <div class="gift-wrap-option-price">+${this.formatCurrency(itemPrice)}</div>
          <label class="gift-wrap-toggle" aria-label="Gift wrap ${this.escapeHTML(item.title)}">
            <input type="checkbox" class="gift-wrap-item-toggle" data-item-key="${this.escapeHTML(key)}" ${this.state.giftWrap.wrappedItems[key] ? 'checked' : ''}>
            <span class="gift-wrap-toggle-track"><span class="gift-wrap-toggle-label"></span></span>
          </label>
        </div>
      `;
    }).join('');

    this.elements.giftWrapItemsList.querySelectorAll('.gift-wrap-item-toggle').forEach(toggle => {
      toggle.addEventListener('change', (e) => {
        const key = e.target.getAttribute('data-item-key');
        this.state.giftWrap.wrappedItems[key] = e.target.checked;
        this.updateTotal();
        this.saveProgress();
      });
    });
  },

  syncGiftWrapUI() {
    if (!this.state.giftWrap) return;
    if (this.elements.giftWrapYourselfToggle) {
      this.elements.giftWrapYourselfToggle.checked = !!this.state.giftWrap.selfWrap;
    }
    if (this.elements.giftWrapPaperPanel) {
      this.elements.giftWrapPaperPanel.classList.toggle('active', !!this.state.giftWrap.selfWrap);
    }
    if (this.elements.giftWrapPenToggle) {
      this.elements.giftWrapPenToggle.checked = !!this.state.giftWrap.penSellotape;
    }
  },

  getGiftWrapAdditionalTotal() {
    if (!this.state.giftWrap) return 0;
    const config = this.getGiftWrapConfig();
    let total = 0;

    this.getIndividualWrapItems().forEach(item => {
      const key = this.getGiftWrapItemKey(item);
      if (this.state.giftWrap.wrappedItems[key]) {
        total += (item.quantity || 1) * this.getGiftWrapItemPrice(item, config);
      }
    });

    if (this.state.giftWrap.selfWrap) {
      config.paperProducts.forEach(paper => {
        const qty = this.state.giftWrap.paperQuantities[paper.key] || 0;
        total += qty * (Number(paper.price) || config.paperFallbackPrice);
      });
      if (this.state.giftWrap.penSellotape) {
        total += config.penSellotapePrice;
      }
    }

    return total;
  },

  getGiftWrapSummary() {
    const config = this.getGiftWrapConfig();
    const paperSelections = [];
    const wrappedSelections = [];
    let wrappedQuantity = 0;

    if (this.state.giftWrap && this.state.giftWrap.selfWrap) {
      config.paperProducts.forEach(paper => {
        const qty = this.state.giftWrap.paperQuantities[paper.key] || 0;
        if (qty > 0) {
          paperSelections.push({ ...paper, quantity: qty });
        }
      });
    }

    if (this.state.giftWrap) {
      this.getIndividualWrapItems().forEach(item => {
        const key = this.getGiftWrapItemKey(item);
        if (this.state.giftWrap.wrappedItems[key]) {
          const quantity = item.quantity || 1;
          wrappedQuantity += quantity;
          wrappedSelections.push({ item, quantity });
        }
      });
    }

    return { config, paperSelections, wrappedSelections, wrappedQuantity };
  },

  getGiftWrapChargeConfigError() {
    if (!this.state.giftWrap) return '';

    const summary = this.getGiftWrapSummary();
    const needsSharedWrapFee = summary.wrappedSelections.some(({ item }) => !item.wrapVariantId);
    const unchargedPaper = summary.paperSelections.find(paper => !paper.variantId && !summary.config.paperFallbackVariantId);
    const needsPenSellotapeFee = this.state.giftWrap.selfWrap && this.state.giftWrap.penSellotape && !summary.config.penSellotapeVariantId;

    if (needsSharedWrapFee && !summary.config.itemWrapVariantId) {
      return 'Gift wrap has been selected, but no £3 Gift Wrap Fee Product is configured. Please choose a £3 product in the theme editor under Gift Wrap Fee Product, or link a fee product on each individual gift wrap item.';
    }

    if (unchargedPaper) {
      return 'Gift wrap paper has been selected, but no £2.50 Gift Wrap Paper Fee Product is configured. Please choose a £2.50 product in the theme editor under Gift Wrap Paper Fee Product, or link products on each paper block.';
    }

    if (needsPenSellotapeFee) {
      return 'Pen and sellotape has been selected, but no £2 Gift Wrap Pen and Sellotape Product is configured. Please choose a £2 product in the theme editor.';
    }

    return '';
  },

  addGiftWrapCartItems(items, hamperId, mainProperties) {
    const summary = this.getGiftWrapSummary();
    const paperText = summary.paperSelections.map(paper => `${paper.label} x ${paper.quantity}`).join(', ');
    const wrappedText = summary.wrappedSelections.map(({ item, quantity }) => `${item.title} x ${quantity}`).join(', ');

    if (this.state.giftWrap.selfWrap) {
      mainProperties['Gift Wrap Yourself'] = 'Yes';
      if (paperText) mainProperties['Gift Wrap Paper'] = paperText;
      if (this.state.giftWrap.penSellotape) mainProperties['Pen and Sellotape'] = 'Yes';
    } else {
      mainProperties['Gift Wrap Yourself'] = 'No';
    }

    if (wrappedText) {
      mainProperties['Items Gift Wrapped'] = wrappedText;
    }

    let aggregateWrappedQuantity = 0;
    const aggregateWrappedText = [];

    summary.wrappedSelections.forEach(({ item, quantity }) => {
      if (item.wrapVariantId) {
        items.push({
          id: parseInt(item.wrapVariantId),
          quantity,
          properties: {
            _builder: true,
            '_hamperLinked': 'true',
            '_hamperId': hamperId,
            '_displayTitle': 'Individual Gift Wrap',
            'Fee Type': 'Gift Wrap',
            'For Product': item.title
          }
        });
        return;
      }

      aggregateWrappedQuantity += quantity;
      aggregateWrappedText.push(`${item.title} x ${quantity}`);
    });

    if (aggregateWrappedQuantity > 0 && summary.config.itemWrapVariantId) {
      items.push({
        id: parseInt(summary.config.itemWrapVariantId),
        quantity: aggregateWrappedQuantity,
        properties: {
          _builder: true,
          '_hamperLinked': 'true',
          '_hamperId': hamperId,
          '_displayTitle': 'Individual Gift Wrap',
          'Fee Type': 'Gift Wrap',
          'For Products': aggregateWrappedText.join(', ')
        }
      });
    }

    summary.paperSelections.forEach(paper => {
      const paperVariantId = paper.variantId || summary.config.paperFallbackVariantId;
      if (!paperVariantId) return;
      items.push({
        id: parseInt(paperVariantId),
        quantity: paper.quantity,
        properties: {
          _builder: true,
          '_hamperLinked': 'true',
          '_hamperId': hamperId,
          '_displayTitle': `Wrapping Paper - ${paper.label}`,
          '_displayImage': this.extractImageUrl(paper.image),
          'Gift Wrap Type': 'Wrapping Paper',
          'Paper': paper.label
        }
      });
    });

    if (this.state.giftWrap.selfWrap && this.state.giftWrap.penSellotape && summary.config.penSellotapeVariantId) {
      items.push({
        id: parseInt(summary.config.penSellotapeVariantId),
        quantity: 1,
        properties: {
          _builder: true,
          '_hamperLinked': 'true',
          '_hamperId': hamperId,
          '_displayTitle': 'Pen and Sellotape',
          'Gift Wrap Type': 'Pen and Sellotape'
        }
      });
    }
  },

  // Setup messaging step
  setupMessaging() {
    // Show luxury box messaging if selected
    if (this.state.selectedBox && this.state.selectedBox.type === 'luxury-box') {
      this.elements.luxuryBoxMessaging.style.display = 'block';
    } else {
      this.elements.luxuryBoxMessaging.style.display = 'none';
    }

    // Update summary section
    this.updateSummarySection();
  },

  // Show or hide "This field is required" text under an input
  toggleFieldError(inputEl, show) {
    if (!inputEl) return;
    const formGroup = inputEl.closest('.form-group');
    if (!formGroup) return;
    let errEl = formGroup.querySelector('.field-error');
    if (show) {
      if (!errEl) {
        errEl = document.createElement('div');
        errEl.className = 'field-error';
        errEl.textContent = 'This field is required';
        errEl.style.cssText = 'color:#d32f2f;font-size:12px;margin-top:4px;';
        formGroup.appendChild(errEl);
      }
      inputEl.style.borderColor = '#d32f2f';
    } else {
      if (errEl) errEl.remove();
      inputEl.style.borderColor = '';
    }
  },

  // Update the summary section
  updateSummarySection() {
    // Update box name
    if (this.elements.summaryBoxName) {
      if (this.state.selectedBox) {
        let boxName = this.state.selectedBox.name;
        if (this.state.selectedBox.color) {
          boxName += ` (${this.state.selectedBox.color.charAt(0).toUpperCase() + this.state.selectedBox.color.slice(1)})`;
        }
        this.elements.summaryBoxName.textContent = boxName;
      } else {
        this.elements.summaryBoxName.textContent = 'No box selected';
      }
    }

    // Update items count
    if (this.elements.summaryItemsCount) {
      const totalItems = this.state.selectedItems.reduce((sum, item) => sum + item.quantity, 0);
      this.elements.summaryItemsCount.textContent = `${totalItems} Selected Items`;
    }

    // Update total price
    this.updateSummaryTotal();
  },

  // Update summary total
  updateSummaryTotal() {
    if (!this.elements.summaryTotalPrice) return;

    let total = 0;

    // Box price
    if (this.state.selectedBox) {
      total += this.state.selectedBox.price;
    }

    // Items price
    this.state.selectedItems.forEach(item => {
      total += item.price * item.quantity;
    });

    // Box personalisation price
    if (this.state.messaging.boxPersonalisation) {
      const option = this.elements.boxPersonalisation.querySelector(`option[value="${this.state.messaging.boxPersonalisation}"]`);
      if (option) {
        total += parseFloat(option.getAttribute('data-price') || 0);
      }
    }

    // Personalisation price
    Object.values(this.state.personalisations).forEach(personalisation => {
      total += personalisation.price || 0;
    });

    // Logo personalisation is currently free; keep the calculation path for future pricing.
    Object.keys(this.state.logoPersonalisations).forEach(() => {
      total += this.LOGO_PERSONALISATION_PRICE;
    });

    total += this.getGiftWrapAdditionalTotal();
    total += this.getSelectedThemedCardPrice();

    this.elements.summaryTotalPrice.textContent = `£${total.toFixed(2)}`;
  },

  // Submit Hamper to cart
  async submitHamper() {
    // Validation guard before submitting
    const leaveBlank = this.elements.leaveBlankCheckbox && this.elements.leaveBlankCheckbox.checked;
    const toEmpty = !this.elements.giftTagTo || this.elements.giftTagTo.value.trim() === '';
    const fromEmpty = !this.elements.giftTagFrom || this.elements.giftTagFrom.value.trim() === '';

    if (!leaveBlank && (toEmpty || fromEmpty)) {
      // Show inline errors under each empty field
      this.toggleFieldError(this.elements.giftTagTo, toEmpty);
      this.toggleFieldError(this.elements.giftTagFrom, fromEmpty);
      // Show alert
      // alert('Please add in Gift tag To & From or select "Please leave blank" to proceed');
      return;
    }

    console.log('🚀 ===== SUBMIT HAMPER CALLED =====');
    console.log('🚀 Selected items:', this.state.selectedItems.length);
    console.log('🚀 Personalisations state:', this.state.personalisations);
    console.log('🚀 All selected items:', this.state.selectedItems.map(i => ({
      title: i.title,
      id: i.id,
      shopifyProductId: i.shopifyProductId,
      selectedVariantId: i.selectedVariantId
    })));
    
    // Show loading on both buttons
    const loadingSpinners = document.querySelectorAll('.btn-add-to-basket .loading, .btn-add-to-basket-summary .loading');
    loadingSpinners.forEach(spinner => {
      if (spinner) spinner.style.display = 'inline-block';
    });

    // Disable both buttons
    if (this.elements.addToBasket) this.elements.addToBasket.disabled = true;
    if (this.elements.addToBasketSummary) this.elements.addToBasketSummary.disabled = true;

    try {
      const giftWrapConfigError = this.getGiftWrapChargeConfigError();
      if (giftWrapConfigError) {
        alert(giftWrapConfigError);
        loadingSpinners.forEach(spinner => { if (spinner) spinner.style.display = 'none'; });
        if (this.elements.addToBasket) this.elements.addToBasket.disabled = false;
        if (this.elements.addToBasketSummary) this.elements.addToBasketSummary.disabled = false;
        return;
      }

      // If in editing mode, first remove the original hamper from cart
      if (this.state.isEditingMode && this.state.originalHamperId) {
        console.log('🗑️ Removing original hamper from cart:', this.state.originalHamperId);
        await this.removeOriginalHamperFromCart(this.state.originalHamperId);
      }
      
      // Prepare cart items
      const items = [];
      
      // Generate a unique hamper ID for this submission
      const hamperId = this.state.isEditingMode && this.state.originalHamperId
        ? this.state.originalHamperId
        : 'hamper_' + Date.now() + '_' + Math.random().toString(36).substring(2, 8);
      console.log(this.state.isEditingMode ? '🆔 Reusing edited hamper ID:' : '🆔 Generated new hamper ID:', hamperId);

      // Build properties object for main product (box)
      const mainProperties = {};

      // Add hamper identification properties
      mainProperties['_isHamperMain'] = 'true';
      mainProperties['_hamperId'] = hamperId;
      mainProperties['Hamper Type'] = 'Build Your Own';

      // Add box
      if (this.state.selectedBox) {
        console.log('=== DEBUG: Selected Box ===');
        console.log('Box state:', this.state.selectedBox);
        console.log('window.boxVariantIds:', window.boxVariantIds);
        console.log('window.boxPrices:', window.boxPrices);

        const boxVariantId = this.getBoxVariantId();

        console.log('Returned boxVariantId:', boxVariantId);

        if (!boxVariantId) {
          console.error('Box variant ID not found. Selected box:', this.state.selectedBox);
          alert('Error: Could not find the selected box product. Please select a box again or contact support.');

          // Reset buttons
          loadingSpinners.forEach(spinner => { if (spinner) spinner.style.display = 'none'; });
          if (this.elements.addToBasket) this.elements.addToBasket.disabled = false;
          if (this.elements.addToBasketSummary) this.elements.addToBasketSummary.disabled = false;
          return;
        }

        // Add box selection to main properties
        mainProperties['Box Selection'] = this.state.selectedBox.name + (this.state.selectedBox.color ? ` (${this.state.selectedBox.color})` : '');

        // Add box personalisation if selected
        if (this.state.messaging.boxPersonalisation) {
          mainProperties['Box Personalisation'] = this.state.messaging.boxPersonalisation === 'inside-outside' ?
            'Messages Both Inside and Outside' : 'Message On the Box Front';
          if (this.state.messaging.boxInsideMessage) {
            mainProperties['Inside Message'] = this.state.messaging.boxInsideMessage;
          }
          if (this.state.messaging.boxOutsideMessage) {
            mainProperties['Outside Message'] = this.state.messaging.boxOutsideMessage;
          }
        }

        // Add gift tag info
        if (this.state.messaging.giftTag) {
          const giftTagTo = this.elements.giftTagTo.value.trim();
          const giftTagFrom = this.elements.giftTagFrom.value.trim();
          const giftMessage = this.elements.giftMessage.value.trim();
          
          if (giftTagTo) mainProperties['Gift Tag To'] = giftTagTo;
          if (giftTagFrom) mainProperties['Gift Tag From'] = giftTagFrom;
          if (giftMessage) mainProperties['Gift Message'] = giftMessage;
        }

        console.log('📝 Main product properties:', mainProperties);
        console.log('Adding box to cart:', {
          id: boxVariantId,
          quantity: 1,
          properties: mainProperties
        });

        items.push({
          id: boxVariantId,
          quantity: 1,
          properties: mainProperties
        });

        this.addGiftWrapCartItems(items, hamperId, mainProperties);
      } else {
        console.error('No box selected!');
        alert('Please select a box first.');

        // Reset buttons
        loadingSpinners.forEach(spinner => { if (spinner) spinner.style.display = 'none'; });
        if (this.elements.addToBasket) this.elements.addToBasket.disabled = false;
        if (this.elements.addToBasketSummary) this.elements.addToBasketSummary.disabled = false;
        return;
      }

      // Defensive: if selected items include sold-out variants (stale data), stop before cart/add
      const soldOutSelections = this.state.selectedItems.filter(i => i.selectedVariantObj && i.selectedVariantObj.available === false);
      if (soldOutSelections.length > 0) {
        const names = soldOutSelections.map(i => i.title).join(', ');
        alert(`Some items in your hamper are now sold out: ${names}. Please remove them and try again.`);

        // Reset buttons
        loadingSpinners.forEach(spinner => { if (spinner) spinner.style.display = 'none'; });
        if (this.elements.addToBasket) this.elements.addToBasket.disabled = false;
        if (this.elements.addToBasketSummary) this.elements.addToBasketSummary.disabled = false;
        return;
      }

      // Add selected items as linked items
      for (const item of this.state.selectedItems) {
        const variantId = item.selectedVariantId || (item.variants && item.variants[0] ? item.variants[0].id : item.id);
        // CRITICAL: Use shopifyProductId for matching personalisations
        const shopifyProductId = item.shopifyProductId || item.id;

        console.log('📦 Processing item:', item.title);
        console.log('   - Shopify Product ID:', shopifyProductId);
        console.log('   - Variant ID:', variantId);
        console.log('   - Quantity:', item.quantity);

        // Check for personalisations for this item using shopifyProductId
        const itemPersonalisations = [];
        const itemPersonalisationGroups = [];
        for (let i = 0; i < item.quantity; i++) {
          const itemKey = `${shopifyProductId}_${i}`;
          console.log('   - Checking key:', itemKey, '→', this.state.personalisations[itemKey] ? 'FOUND' : 'not found');
          
          if (this.state.personalisations[itemKey]) {
            const personalisation = this.state.personalisations[itemKey];
            // Only add personalisation if value is not blank
            if (personalisation.value && personalisation.value.trim() !== '') {
              itemPersonalisations.push(personalisation);
              console.log('   - ✓ Personalisation:', personalisation.value);
            } else {
              console.log('   - ⚠️ Blank personalisation detected, skipping');
            }
          }
          // Note: We no longer add default personalisations for items that can be personalised
          // Only actual user-entered personalisations will be added
        }

        for (let i = 0; i < item.quantity; i++) {
          const itemKey = `${shopifyProductId}_${i}`;
          const groupedKeys = Object.keys(this.state.personalisations || {}).filter(key => (
            key === itemKey || key.startsWith(`${itemKey}__`)
          ));
          const groupedPersonalisations = groupedKeys
            .map(key => this.state.personalisations[key])
            .filter(personalisation => personalisation && personalisation.value && personalisation.value.trim() !== '');

          if (groupedPersonalisations.length) {
            groupedPersonalisations.forEach(personalisation => {
              if (!itemPersonalisations.includes(personalisation)) {
                itemPersonalisations.push(personalisation);
              }
            });
            itemPersonalisationGroups.push({
              itemKey,
              personalisations: groupedPersonalisations
            });
          }
        }

        console.log('   - Total personalisations found:', itemPersonalisations.length);

        // Check for logo personalisation for this item (any quantity)
        let itemLogoUrl = null;
        let itemLogoFilename = null;
        for (let i = 0; i < item.quantity; i++) {
          const itemKey = `${shopifyProductId}_${i}`;
          if (this.state.logoPersonalisations[itemKey]) {
            itemLogoUrl = this.state.logoPersonalisations[itemKey].logoUrl;
            itemLogoFilename = this.state.logoPersonalisations[itemKey].logoFilename;
            console.log('   - ✓ Logo personalisation found:', itemLogoUrl);
            break; // One logo per item type
          }
        }

        if (itemPersonalisationGroups.length > 0) {
          // Add each personalised unit separately, keeping multiple text options on the same cart line.
          itemPersonalisationGroups.forEach((group) => {
            const itemProperties = {
              _builder: true,
              '_hamperLinked': 'true',
              '_hamperId': hamperId
            };

            const typeLabels = [];
            group.personalisations.forEach((personalisation, index) => {
              const propertyName = this.getPersonalisationPropertyName(personalisation);
              itemProperties[propertyName] = personalisation.value;
              if (index === 0) {
                itemProperties['Personalisation'] = personalisation.value;
              }
              typeLabels.push(this.getPersonalisationTypeLabel(personalisation));
            });
            itemProperties['Personalisation Type'] = typeLabels.join(', ');

            // Attach logo URL if this item has logo personalisation
            if (itemLogoUrl) {
              itemProperties['Personalisation Logo'] = itemLogoUrl;
              if (itemLogoFilename) {
                itemProperties['Logo Filename'] = itemLogoFilename;
              }
            }

            items.push({
              id: variantId,
              quantity: 1,
              properties: itemProperties
            });
          });

          // Add personalisation fees - grouped by price
          const personalisationsWithFee = itemPersonalisations.filter(p => p.price > 0);
          
          // Group personalizations by price
          const feesByPrice = {};
          personalisationsWithFee.forEach(p => {
            const price = p.price;
            if (!feesByPrice[price]) {
              feesByPrice[price] = [];
            }
            feesByPrice[price].push(p);
          });

          // Add separate cart items for each price tier
          Object.entries(feesByPrice).forEach(([price, personalisations]) => {
            const priceNum = parseFloat(price);
            let feeVariantId;
            
            // Map price to variant ID
            if (priceNum === 2.00) {
              feeVariantId = 54810509377870; // £2 fee variant
              console.log('   - Adding £2 personalisation fee (qty:', personalisations.length, ')');
            } else if (priceNum === 4.00) {
              feeVariantId = 53053291692366; // £4 fee variant
              console.log('   - Adding £4 personalisation fee (qty:', personalisations.length, ')');
            } else {
              // Fallback: for £0 or custom prices, use the £2 variant
              feeVariantId = 54810509377870;
              console.log('   - Adding custom price fee:', priceNum, '(qty:', personalisations.length, ')');
            }

            items.push({
              id: feeVariantId,
              quantity: personalisations.length,
              properties: {
                _builder: true,
                '_hamperLinked': 'true',
                '_hamperId': hamperId,
                'Fee Type': `Personalisation (£${priceNum.toFixed(2)} each)`,
                'For Products': `${item.title} (${personalisations.length} items)`
              }
            });
          });

          // Add remaining non-personalised quantity
          const remainingQty = item.quantity - itemPersonalisationGroups.length;
          if (remainingQty > 0) {
            const remainingProps = {
              _builder: true,
              '_hamperLinked': 'true',
              '_hamperId': hamperId
            };

            // Attach logo URL if this item has logo personalisation
            if (itemLogoUrl) {
              remainingProps['Personalisation Logo'] = itemLogoUrl;
              if (itemLogoFilename) {
                remainingProps['Logo Filename'] = itemLogoFilename;
              }
            }

            items.push({
              id: variantId,
              quantity: remainingQty,
              properties: remainingProps
            });
          }
        } else {
          // No personalisation, add all at once
          const itemProps = {
            _builder: true,
            '_hamperLinked': 'true',
            '_hamperId': hamperId,
            'Product Title': item.title,
            ...(item.selectedVariantTitle ? { 'Variant': item.selectedVariantTitle } : {})
          };

          // Attach logo URL if this item has logo personalisation
          if (itemLogoUrl) {
            itemProps['Personalisation Logo'] = itemLogoUrl;
            if (itemLogoFilename) {
              itemProps['Logo Filename'] = itemLogoFilename;
            }
          }

          items.push({
            id: variantId,
            quantity: item.quantity,
            properties: itemProps
          });
        }
      }

      const selectedThemedCard = this.state.selectedThemedCard;
      if (selectedThemedCard && selectedThemedCard.variantId) {
        const cardVariantId = parseInt(selectedThemedCard.variantId, 10);
        if (!Number.isNaN(cardVariantId) && !items.some(item => Number(item.id) === cardVariantId)) {
          items.push({
            id: cardVariantId,
            quantity: 1,
            properties: {
              _builder: true,
              '_hamperLinked': 'true',
              '_hamperId': hamperId,
              'isWeddingCard': 'true',
              'Product Title': selectedThemedCard.title || 'Themed Card'
            }
          });
        }
      }

      // Logo personalisation fee line is intentionally hidden while price is 0.
      // If logo personalisation becomes paid again later, increase LOGO_PERSONALISATION_PRICE.
      const uniqueItemsWithLogos = new Set();
      Object.keys(this.state.logoPersonalisations).forEach(key => {
        const logoData = this.state.logoPersonalisations[key];
        uniqueItemsWithLogos.add(logoData.shopifyProductId);
      });

      if (uniqueItemsWithLogos.size > 0 && this.LOGO_PERSONALISATION_PRICE > 0) {
        const itemTitles = [];
        uniqueItemsWithLogos.forEach(shopifyProductId => {
          const item = this.state.selectedItems.find(i => (i.shopifyProductId || i.id) === shopifyProductId);
          if (item) itemTitles.push(item.title);
        });

        console.log('🏷️ Adding logo variant for', uniqueItemsWithLogos.size, 'items:', itemTitles.join(', '));

        items.push({
          id: '59140647682382',
          quantity: uniqueItemsWithLogos.size,
          properties: {
            _builder: true,
            '_hamperLinked': 'true',
            '_hamperId': hamperId,
            'Fee Type': 'Logo Personalisation',
            'For Products': itemTitles.join(', ')
          }
        });
      }

      // Add box personalisation products based on selection and input (only if luxury-box-messaging is visible)
      const luxuryBoxMessagingForProducts = document.getElementById('luxury-box-messaging');
      const isLuxuryBoxMessagingVisibleForProducts = luxuryBoxMessagingForProducts && luxuryBoxMessagingForProducts.style.display !== 'none' && luxuryBoxMessagingForProducts.offsetParent !== null;

      const boxPersonalisationValue = this.state.messaging.boxPersonalisation;
      const boxInsideMessage = (this.elements.boxInsideMessage && this.elements.boxInsideMessage.value) || '';
      const boxOutsideMessage = (this.elements.boxOutsideMessage && this.elements.boxOutsideMessage.value) || '';

      // For 'front-only'
      if (
        boxPersonalisationValue === 'front-only' &&
        boxOutsideMessage.trim() !== '' &&
        isLuxuryBoxMessagingVisibleForProducts
      ) {
        const frontOnlyProperties = {
          _builder: true,
          '_hamperLinked': 'true',
          '_hamperId': hamperId,
          'Fee Type': 'Box Personalisation',
          'Box Personalisation': 'Front Only'
        };

        if (boxOutsideMessage.trim()) {
          frontOnlyProperties['Outside Message'] = boxOutsideMessage.trim();
        }

        if (window.boxPersonalisationFrontVariantId) {
          items.push({
            id: parseInt(window.boxPersonalisationFrontVariantId),
            quantity: 1,
            properties: frontOnlyProperties
          });
        } else {
          console.warn('Box Personalisation Front variant ID not configured in section settings');
        }
      }

      // For 'inside-outside'
      if (
        boxPersonalisationValue === 'inside-outside' &&
        boxInsideMessage.trim() !== '' &&
        boxOutsideMessage.trim() !== '' &&
        isLuxuryBoxMessagingVisibleForProducts
      ) {
        const insideOutsideProperties = {
          _builder: true,
          '_hamperLinked': 'true',
          '_hamperId': hamperId,
          'Fee Type': 'Box Personalisation',
          'Box Personalisation': 'Inside & Outside'
        };

        if (boxInsideMessage.trim()) {
          insideOutsideProperties['Inside Message'] = boxInsideMessage.trim();
        }
        if (boxOutsideMessage.trim()) {
          insideOutsideProperties['Outside Message'] = boxOutsideMessage.trim();
        }

        if (window.boxPersonalisationInsideOutsideVariantId) {
          items.push({
            id: parseInt(window.boxPersonalisationInsideOutsideVariantId),
            quantity: 1,
            properties: insideOutsideProperties
          });
        } else {
          console.warn('Box Personalisation Inside & Outside variant ID not configured in section settings');
        }
      }

      console.log('Items to add to cart:', items);

      // Add items to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Cart API Error Response:', errorText);
        throw new Error('Failed to add items to cart');
      }

      // Update cart UI
      const cart = await response.json();
      this.updateCartUI(cart);

      // Clear progress and editing data from localStorage
      localStorage.removeItem('hamperBuilderProgress');
      localStorage.removeItem('editingHamperData');

      // Clear editing mode
      this.state.isEditingMode = false;
      this.state.originalHamperId = null;

      // Success - redirect to cart
      setTimeout(() => {
        window.location.href = '/cart';
      }, 500);

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('There was an error adding your hamper to the cart. Please try again.');

      // Reset both buttons
      const loadingSpinners = document.querySelectorAll('.btn-add-to-basket .loading, .btn-add-to-basket-summary .loading');
      loadingSpinners.forEach(spinner => {
        if (spinner) spinner.style.display = 'none';
      });

      if (this.elements.addToBasket) this.elements.addToBasket.disabled = false;
      if (this.elements.addToBasketSummary) this.elements.addToBasketSummary.disabled = false;
    }
  },

  // Check for editing hamper data from cart
  checkForEditingHamperData() {
    try {
      const editingDataJSON = localStorage.getItem('editingHamperData');
      if (editingDataJSON) {
        console.log('📝 Found editing hamper data in localStorage');
        const editingData = JSON.parse(editingDataJSON);
        console.log('📝 Editing data:', editingData);

        // Set editing mode
        this.state.isEditingMode = true;
        this.state.originalHamperId = editingData.hamperId;

        // Auto-select box from editing data
        this.autoSelectBoxFromEditingData(editingData);

        // Auto-populate messaging data
        this.autoPopulateMessagingData(editingData);

        // Auto-select items from editing data
        this.autoSelectItemsFromEditingData(editingData);

        // Auto-populate personalisations
        this.autoPopulatePersonalisationData(editingData);

        if (editingData.isReorder) {
          this.showReorderNotice(editingData);
        }

        // Clear the localStorage after loading
        localStorage.removeItem('editingHamperData');

        console.log('✅ Editing mode activated');
      }
    } catch (error) {
      console.error('Error loading editing hamper data:', error);
      // Clear corrupted data
      localStorage.removeItem('editingHamperData');
    }
  },

  showReorderNotice(editingData) {
    setTimeout(() => {
      const wrapper = document.querySelector('.hamper-content-wrapper') || document.getElementById('build-your-own-app');
      if (!wrapper || document.querySelector('.reorder-builder-notice')) return;

      const unavailableItems = Array.isArray(editingData.unavailableItems) ? editingData.unavailableItems.filter(Boolean) : [];
      const notice = document.createElement('div');
      notice.className = 'reorder-builder-notice';
      notice.innerHTML = `
        <strong>Previous hamper loaded</strong>
        <span>We recreated your previous bundle where possible. Please review your items before checkout.</span>
        ${unavailableItems.length ? `<span class="reorder-builder-notice__warning">Unavailable items skipped: ${unavailableItems.join(', ')}</span>` : ''}
      `;
      wrapper.insertAdjacentElement('beforebegin', notice);
    }, 100);
  },

  // Auto-select box from editing data
  autoSelectBoxFromEditingData(editingData) {
    if (!editingData.personalisations || !editingData.personalisations['Box Selection']) {
      console.log('⚠️ No box selection found in editing data');
      return;
    }

    const targetBoxSelection = editingData.personalisations['Box Selection'];
    console.log('📦 Target box selection:', targetBoxSelection);

    // Wait for DOM to be fully loaded
    setTimeout(() => {
      // Find and click the matching box option
      const boxOptions = document.querySelectorAll('.box-option');
      let foundBox = false;

      boxOptions.forEach(option => {
        const boxTitle = option.querySelector('.box-option-title');
        if (boxTitle) {
          const optionName = boxTitle.textContent.trim();
          
          // Check if this box matches
          if (targetBoxSelection.includes(optionName)) {
            console.log('✅ Found matching box:', optionName);
            
            // Click to select the box
            option.click();
            foundBox = true;

            // If the box has color variants, select the appropriate color
            if (targetBoxSelection.includes('(') && targetBoxSelection.includes(')')) {
              const colorMatch = targetBoxSelection.match(/\\((.+)\\)/);
              if (colorMatch && colorMatch[1]) {
                const colorValue = colorMatch[1].toLowerCase();
                const colorSelect = option.querySelector('.box-color-option');
                
                if (colorSelect) {
                  setTimeout(() => {
                    colorSelect.value = colorValue;
                    colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    console.log('✅ Selected box color:', colorValue);
                  }, 100);
                }
              }
            }
          }
        }
      });

      if (!foundBox) {
        console.log('❌ Could not find matching box for:', targetBoxSelection);
      }
    }, 500);
  },

  // Auto-populate messaging data from editing data
  autoPopulateMessagingData(editingData) {
    if (!editingData || !editingData.personalisations) {
      return;
    }

    const personalisations = editingData.personalisations;
    console.log('📝 Auto-populating messaging data:', personalisations);

    // Wait for DOM to load
    setTimeout(() => {
      // Gift tag fields
      if (personalisations['Gift Tag To']) {
        const giftTagToInput = document.getElementById('gift-tag-to');
        if (giftTagToInput) {
          giftTagToInput.value = personalisations['Gift Tag To'];
          this.state.messaging.giftTagTo = personalisations['Gift Tag To'];
        }
      }

      if (personalisations['Gift Tag From']) {
        const giftTagFromInput = document.getElementById('gift-tag-from');
        if (giftTagFromInput) {
          giftTagFromInput.value = personalisations['Gift Tag From'];
          this.state.messaging.giftTagFrom = personalisations['Gift Tag From'];
        }
      }

      if (personalisations['Gift Message']) {
        const giftMessageInput = document.getElementById('gift-message');
        if (giftMessageInput) {
          giftMessageInput.value = personalisations['Gift Message'];
          this.state.messaging.giftMessage = personalisations['Gift Message'];
        }
      }

      // Box personalisation fields
      if (personalisations['Inside Message'] || personalisations['Outside Message']) {
        // Determine box personalisation type
        const hasInside = !!personalisations['Inside Message'];
        const hasOutside = !!personalisations['Outside Message'];
        
        let personalisationType = '';
        if (hasInside && hasOutside) {
          personalisationType = 'inside-outside';
        } else if (hasOutside) {
          personalisationType = 'front-only';
        } else if (hasInside) {
          personalisationType = 'inside-only';
        }

        if (personalisationType) {
          const boxPersonalisationSelect = document.getElementById('box-personalisation');
          if (boxPersonalisationSelect) {
            boxPersonalisationSelect.value = personalisationType;
            boxPersonalisationSelect.dispatchEvent(new Event('change', { bubbles: true }));
            this.state.messaging.boxPersonalisation = personalisationType;
          }

          // Wait for personalisation fields to appear
          setTimeout(() => {
            if (personalisations['Inside Message']) {
              const insideInput = document.getElementById('box-inside-message');
              if (insideInput) {
                insideInput.value = personalisations['Inside Message'];
                this.state.messaging.boxInsideMessage = personalisations['Inside Message'];
              }
            }

            if (personalisations['Outside Message']) {
              const outsideInput = document.getElementById('box-outside-message');
              if (outsideInput) {
                outsideInput.value = personalisations['Outside Message'];
                this.state.messaging.boxOutsideMessage = personalisations['Outside Message'];
              }
            }
          }, 500);
        }
      }

      console.log('✅ Messaging data populated');
    }, 1000);
  },

  // Auto-populate personalisations from editing data
  autoPopulatePersonalisationData(editingData) {
    if (!editingData.linkedItems || editingData.linkedItems.length === 0) {
      console.log('⚠️ No linked items for personalisation restoration');
      return;
    }

    console.log('🎨 Auto-populating personalisations from cart data');

    // Wait for items to be loaded and personalisation step to be set up
    setTimeout(() => {
      editingData.linkedItems.forEach(linkedItem => {
        // Check if this item has personalisation data in its properties
        if (linkedItem.properties && linkedItem.properties.Personalisation) {
          console.log('🎨 Found personalisation for:', linkedItem.title, linkedItem.properties.Personalisation);

          // Find the matching product in selectedItems
          const matchingItem = this.state.selectedItems.find(item => {
            return item.variantId === linkedItem.variantId || 
                   item.id === linkedItem.variantId ||
                   item.title === linkedItem.title;
          });

          if (matchingItem) {
            // Create personalisation entry in state
            // Determine which instance of the item this is (for quantity > 1)
            const itemKey = `${matchingItem.id}_0`; // Simplified - use first instance

            // Extract personalisation type from properties
            let personalisationType = 'text';
            let personalisationPrice = 0; // Will be set based on actual type

            if (linkedItem.properties['Personalisation Type']) {
              const typeString = linkedItem.properties['Personalisation Type'].toLowerCase();
              if (typeString.includes('initial')) {
                personalisationType = 'initials';
                personalisationPrice = 4.00;
              } else if (typeString.includes('bottle')) {
                personalisationType = 'bottle';
                personalisationPrice = 0.00;
              } else if (typeString.includes('bunny')) {
                personalisationType = 'bunnytoy';
                personalisationPrice = 4.00;
              } else if (typeString.includes('oxton') || typeString.includes('message')) {
                personalisationType = 'oxton';
                personalisationPrice = 2.00;
              } else if (typeString.includes('keyring')) {
                personalisationType = 'keyring';
                personalisationPrice = 2.00;
              } else {
                // Try to extract price from the label if available
                const priceMatch = typeString.match(/£(\d+\.?\d*)/);                if (priceMatch) {
                  personalisationPrice = parseFloat(priceMatch[1]);
                } else {
                  personalisationPrice = 4.00; // Fallback default
                }
              }
            }

            this.state.personalisations[itemKey] = {
              value: linkedItem.properties.Personalisation,
              type: personalisationType,
              price: personalisationPrice,
              itemId: matchingItem.id,
              label: linkedItem.properties['Personalisation Type'] || 'Personalisation'
            };

            console.log('✅ Restored personalisation:', itemKey, this.state.personalisations[itemKey]);
          }
        }

        // Check if this item has logo personalisation
        if (linkedItem.properties && linkedItem.properties['Personalisation Logo']) {
          console.log('🏷️ Found logo personalisation for:', linkedItem.title, linkedItem.properties['Personalisation Logo']);

          // Find the matching product in selectedItems
          const matchingItem = this.state.selectedItems.find(item => {
            return item.variantId === linkedItem.variantId || 
                   item.id === linkedItem.variantId ||
                   item.title === linkedItem.title;
          });

          if (matchingItem) {
            const itemKey = `${matchingItem.id}_0`; // Simplified - use first instance

            this.state.logoPersonalisations[itemKey] = {
              shopifyProductId: matchingItem.id,
              variantId: linkedItem.variantId,
              logoUrl: linkedItem.properties['Personalisation Logo'],
              logoFilename: linkedItem.properties['Logo Filename'] || 'logo.png',
              itemTitle: linkedItem.title
            };

            console.log('✅ Restored logo personalisation:', itemKey, this.state.logoPersonalisations[itemKey]);
          }
        }
      });

      console.log('✅ Personalisation data restored:', this.state.personalisations);
      console.log('✅ Logo personalisation data restored:', this.state.logoPersonalisations);
    }, 2000); // Wait longer for items to be fully loaded
  },

  // Auto-select items from editing data
  autoSelectItemsFromEditingData(editingData) {
    if (!editingData.linkedItems || editingData.linkedItems.length === 0) {
      console.log('⚠️ No linked items found in editing data');
      return;
    }

    console.log('🔄 Auto-selecting items:', editingData.linkedItems);

    // Wait for products to load
    const checkProducts = setInterval(() => {
      if (this.state.allProducts && this.state.allProducts.length > 0) {
        clearInterval(checkProducts);

        editingData.linkedItems.forEach(linkedItem => {
          // Skip system items (personalisation fees, box personalisation products, logo personalisation)
          if (linkedItem.title.includes('Personalisation Fee') || 
              linkedItem.title.includes('Box Personalisation') ||
              linkedItem.title.includes('Logo Personalisation') ||
              linkedItem.variantId === '59140647682382') {
            return;
          }

          // Find matching product
          const matchingProduct = this.state.allProducts.find(product => {
            return product.title === linkedItem.title || 
                   product.variants.some(v => v.id === linkedItem.variantId);
          });

          if (matchingProduct) {
            console.log('✅ Found matching product:', matchingProduct.title);
            
            // Add to selected items
            const existingItem = this.state.selectedItems.find(item => item.id === matchingProduct.id);
            if (existingItem) {
              existingItem.quantity += linkedItem.quantity;
            } else {
              this.state.selectedItems.push({
                ...matchingProduct,
                quantity: linkedItem.quantity,
                selectedVariantId: linkedItem.variantId
              });
            }
          } else {
            console.log('❌ Could not find matching product for:', linkedItem.title);
          }
        });

        // Update UI
        this.updateSidebarItems();
        this.updateTotal();
        this.updateItemButtons();
        this.updateStickyBars();

        console.log('✅ Items auto-selected:', this.state.selectedItems.length);
      }
    }, 500);

    // Timeout after 10 seconds
    setTimeout(() => {
      clearInterval(checkProducts);
    }, 10000);
  },

  // Remove original hamper from cart when editing
  async removeOriginalHamperFromCart(hamperId) {
    try {
      console.log('🗑️ Starting removal of original hamper:', hamperId);

      // Fetch current cart
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) {
        throw new Error('Failed to fetch cart');
      }
      const cart = await cartResponse.json();

      console.log('🛒 Current cart items:', cart.items.length);

      // Find all items that belong to this hamper
      const itemsToRemove = cart.items
        .map((item, index) => ({
          key: item.key,
          title: item.title,
          properties: item.properties
        }))
        .filter(({ properties }) => 
          properties && 
          properties._hamperId === hamperId
        );

      console.log('🗑️ Found items to remove:', itemsToRemove.length);
      itemsToRemove.forEach(item => {
        console.log('  - Removing:', item.title, 'Key:', item.key);
      });

      if (itemsToRemove.length === 0) {
        console.log('⚠️ No items found with hamperId:', hamperId);
        return;
      }

      // Build updates object - set all matching items to quantity 0
      const updates = {};
      itemsToRemove.forEach(item => {
        updates[item.key] = 0;
      });

      console.log('🗑️ Sending cart update with:', updates);

      // Update cart with all removals at once
      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      if (!updateResponse.ok) {
        const errorText = await updateResponse.text();
        console.error('Failed to update cart:', errorText);
        throw new Error('Failed to update cart');
      }

      const updatedCart = await updateResponse.json();
      console.log('✅ Original hamper removed. New cart count:', updatedCart.item_count);

      // Small delay to ensure cart is updated
      await new Promise(resolve => setTimeout(resolve, 300));

    } catch (error) {
      console.error('❌ Error removing original hamper:', error);
      throw error;
    }
  },

  // Get box variant ID based on selection
  getBoxVariantId() {
    if (!window.boxVariantIds) {
      console.error('Box variant IDs not available. Please configure products in section settings.');
      return null;
    }

    let variantKey;
    if (this.state.selectedBox.type === 'wicker-basket') {
      variantKey = `${this.state.selectedBox.type}-${this.state.selectedBox.color}`;
    } else if (this.state.selectedBox.type === 'luxury-box') {
      variantKey = `${this.state.selectedBox.type}-${this.state.selectedBox.color}`;
    } else {
      variantKey = this.state.selectedBox.type;
    }

    const variantId = window.boxVariantIds[variantKey];

    if (!variantId) {
      console.error(`No variant ID found for: ${variantKey}`);
      return null;
    }

    console.log(`Box variant ID for ${variantKey}: ${variantId}`);
    return variantId;
  },

  // New method to handle luxury box price updates if different variants have different prices
  updateLuxuryBoxPrice(color) {
    if (this.state.selectedBox.type === 'luxury-box' && window.boxPrices) {
      const priceKey = `luxury-box-${color}`;
      const newPrice = window.boxPrices[priceKey];

      if (newPrice !== undefined) {
        console.log(`Updating luxury box price from ${this.state.selectedBox.price} to ${newPrice} for color: ${color}`);
        this.state.selectedBox.price = parseFloat(newPrice);
        this.updateTotal();
        this.saveProgress();
      } else {
        console.warn(`No price found for ${priceKey}`);
      }
    }
  },

  // Update cart UI
  updateCartUI(cart) {
    // Update cart count in header
    const cartCountElements = document.querySelectorAll('.cart-count, .cart-count-bubble');
    cartCountElements.forEach(el => {
      el.textContent = cart.item_count;
      el.classList.remove('hidden');
    });

    // Trigger cart drawer if available
    if (typeof window.Shopify !== 'undefined' && window.Shopify.theme && window.Shopify.theme.openCartDrawer) {
      window.Shopify.theme.openCartDrawer();
    }
  },

  // Update UI
  updateUI() {
    this.updateSidebarBox();
    this.updateSidebarItems();
    this.updateItemButtons();
    this.updateTotal();
    this.updateContinueButton();
    this.updateStickyBars();
  },

  // Utility: Debounce function
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },

  // Update price display
  updatePriceDisplay() {
    this.elements.priceMinDisplay.textContent = `£${this.state.filters.priceMin}`;
    this.elements.priceMaxDisplay.textContent = `£${this.state.filters.priceMax}`;

    // Update input fields if they exist
    if (this.elements.priceMinInput) {
      this.elements.priceMinInput.value = this.state.filters.priceMin;
    }
    if (this.elements.priceMaxInput) {
      this.elements.priceMaxInput.value = this.state.filters.priceMax;
    }
  },

  // Get personalisation type from tags
  getPersonalisationType(tags) {
    const personalisationTypes = {
      'personalise:initials': {
        type: 'initials',
        question: 'Would you like this item personalised with initials?',
        label: 'Hot foil engraved initials (£4.00)',
        maxLength: 4,
        placeholder: 'Enter initials',
        price: 4.00
      },
      'personalise:name0': {
        type: 'name',
        question: 'Would you like this item personalised with a name?',
        label: 'Your text (\u00a30.00)',
        maxLength: 15,
        placeholder: 'Enter your text...',
        price: 0.00
      },
      'personalise:message0': {
        type: 'message',
        question: 'Would you like this item personalised with a message?',
        label: 'Your message (\u00a30.00)',
        maxLength: 30,
        placeholder: 'Enter your message...',
        price: 0.00
      },
      'personalise:bunnytoy': {
        type: 'bunnytoy',
        question: 'Would you like to personalise this item?',
        label: 'Add name or initials (£4.00)',
        maxLength: 15,
        placeholder: 'Enter name or initials',
        price: 4.00
      },
      'personalise:bottle': {
        type: 'bottle',
        question: 'Would you like to personalise your bottle?',
        label: 'Personalised message (£0.00)',
        maxLength: 15,
        placeholder: 'Enter message',
        price: 0.00
      },
      'personalise:oxton': {
        type: 'oxton',
        question: 'Would you like this bottle personalised with a message?',
        label: 'Your message (£2.00)',
        maxLength: 25,
        placeholder: 'Enter your message...',
        price: 2.00
      },
      'personalise:25': {
        type: '25',
        question: 'Would you like this item personalised with a message?',
        label: 'Your message (£4.00)',
        maxLength: 25,
        placeholder: 'Enter your message...',
        price: 4.00
      },
      'personalise:baby': {
        type: 'baby',
        question: 'Would you like this item personalised with a name?',
        label: 'Baby\'s name (£4.00)',
        maxLength: 10,
        placeholder: 'Enter baby\'s name...',
        price: 4.00
      },
      'personalise:card': {
        type: 'card',
        question: 'Would you like a complimentory hand written message to be included in your card?',
        label: 'Your message (£4.00)',
        maxLength: 100,
        placeholder: 'Enter your message...',
        price: 4.00
      },
      'personalise:chocribbon': {
        type: 'ribbon',
        question: 'Would you like to personalise this ribbon?',
        label: 'Your text (£4.00)',
        maxLength: 10,
        placeholder: 'Enter your text...',
        price: 4.00
      },
      'personalise:name': {
        type: 'name',
        question: 'Would you like this item personalised with a name?',
        label: 'Your text (£4.00)',
        maxLength: 10,
        placeholder: 'Enter your text...',
        price: 4.00
      },
      'personalise:keyring': {
        type: 'name',
        question: 'Would you like this item personalised with a name or short message?',
        label: 'Your text (£2.00)',
        maxLength: 20,
        placeholder: 'Enter your text...',
        price: 2.00
      },

    };

    const normalisedTags = (tags || []).map(tag => String(tag).toLowerCase());
    const priority = [
      'personalise:name0',
      'personalise:message0',
      'personalise:initials',
      'personalise:bunnytoy',
      'personalise:bottle',
      'personalise:oxton',
      'personalise:25',
      'personalise:baby',
      'personalise:card',
      'personalise:chocribbon',
      'personalise:name',
      'personalise:keyring'
    ];

    for (const tag of priority) {
      if (normalisedTags.includes(tag) && personalisationTypes[tag]) {
        return personalisationTypes[tag];
      }
    }
    return null;
  },

  getPersonalisationPropertyName(personalisation) {
    const type = personalisation && personalisation.type;
    if (['name', 'baby', 'keyring'].includes(type)) return 'Name';
    if (['message', '25', 'card', 'oxton', 'bottle'].includes(type)) return 'Message';
    if (type === 'initials') return 'Initials';
    return 'Personalisation';
  },

  getPersonalisationTypeLabel(personalisation) {
    const type = personalisation && personalisation.type;
    if (type === 'initials') return 'Hot Foil Initials';
    if (type === 'bunnytoy') return 'Name/Initials on Bunny';
    if (type === 'bottle') return 'Bottle Message';
    if (['message', '25', 'card', 'oxton'].includes(type)) return 'Message';
    if (['name', 'baby', 'keyring'].includes(type)) return 'Name';
    return 'Personalisation';
  },

  getPersonalisationTypes(tags) {
    const normalisedTags = (tags || []).map(tag => String(tag).toLowerCase());
    const priority = [
      'personalise:name0',
      'personalise:message0',
      'personalise:initials',
      'personalise:bunnytoy',
      'personalise:bottle',
      'personalise:oxton',
      'personalise:25',
      'personalise:baby',
      'personalise:card',
      'personalise:chocribbon',
      'personalise:name',
      'personalise:keyring'
    ];
    const found = [];
    const seen = new Set();

    priority.forEach(tag => {
      if (!normalisedTags.includes(tag)) return;
      const typeConfig = this.getPersonalisationType([tag]);
      if (!typeConfig) return;
      const key = ['25', 'card', 'oxton', 'message'].includes(typeConfig.type) ? 'message' : typeConfig.type;
      if (seen.has(key)) return;
      found.push({ ...typeConfig, key });
      seen.add(key);
    });

    return found;
  },

  // Get personalisation price from tags
  getPersonalisationPrice(tags) {
    const type = this.getPersonalisationType(tags);
    return type ? type.price : 0;
  },

  // Update filter count
  updateFilterCount() {
    const activeFilters = [];
    const defaultMin = parseInt(this.elements.priceMinRange.getAttribute('min')) || 0;
    const defaultMax = parseInt(this.elements.priceMaxRange.getAttribute('max')) || 1000;

    // Check all filter types
    // if (this.state.filters.hideOutOfStock) activeFilters.push({ type: 'stock', value: 'In Stock' });
    if (this.state.filters.priceMin > defaultMin || this.state.filters.priceMax < defaultMax) {
      activeFilters.push({ type: 'price', value: `£${this.state.filters.priceMin} - £${this.state.filters.priceMax}` });
    }

    this.state.filters.categories.forEach(cat => activeFilters.push({ type: 'category', value: cat }));
    this.state.filters.occasions.forEach(occ => activeFilters.push({ type: 'occasion', value: occ }));
    this.state.filters.personalised.forEach(item => activeFilters.push({ type: 'personalised', value: item }));
    this.state.filters.recipients.forEach(rec => activeFilters.push({ type: 'recipient', value: rec }));
    this.state.filters.sizes.forEach(size => activeFilters.push({ type: 'size', value: size }));
    this.state.filters.vendors.forEach(vendor => activeFilters.push({ type: 'vendor', value: vendor }));
    this.state.filters.availabilities.forEach(avail => activeFilters.push({ type: 'availability', value: avail }));
    this.state.filters.christmasTypes.forEach(type => activeFilters.push({ type: 'christmas_type', value: type }));

    // Add custom filters
    for (const [filterType, values] of Object.entries(this.state.filters.customFilters)) {
      if (values && values.length > 0) {
        values.forEach(v => activeFilters.push({ type: filterType, value: v }));
      }
    }

    const filterCount = activeFilters.length;
    const filterCountElement = document.getElementById('mobile-filter-count');

    if (filterCountElement) {
      if (filterCount > 0) {
        filterCountElement.textContent = `(${filterCount})`;
        filterCountElement.style.display = 'inline';
      } else {
        filterCountElement.style.display = 'none';
      }
    }

    // Update active filters display
    this.updateActiveFiltersDisplay(activeFilters);
  },

  // Update active filters display
  updateActiveFiltersDisplay(activeFilters) {
    if (!this.elements.activeFiltersContainer) return;

    this.elements.activeFiltersContainer.innerHTML = '';

    activeFilters.forEach(filter => {
      const chip = document.createElement('div');
      chip.className = 'active-filter-chip';
      chip.innerHTML = `
        <span>${filter.value}</span>
        <button class="remove-filter" data-filter-type="${filter.type}" data-filter-value="${filter.value}">×</button>
      `;

      chip.querySelector('.remove-filter').addEventListener('click', () => {
        this.removeFilter(filter.type, filter.value);
      });

      this.elements.activeFiltersContainer.appendChild(chip);
    });

    // Show/hide clear all button
    if (this.elements.clearAllFilters) {
      this.elements.clearAllFilters.style.display = activeFilters.length > 0 ? 'block' : 'none';
    }
  },

  // Remove single filter
  removeFilter(type, value) {
    let checkbox;
    switch (type) {
      case 'category':
        this.state.filters.categories = this.state.filters.categories.filter(c => c !== value);
        // Find checkbox by comparing trimmed values
        checkbox = Array.from(document.querySelectorAll('input[data-filter-type="category"]')).find(cb => 
          cb.getAttribute('data-filter-value').trim() === value
        );
        if (checkbox) checkbox.checked = false;
        break;
      case 'occasion':
        this.state.filters.occasions = this.state.filters.occasions.filter(o => o !== value);
        checkbox = Array.from(document.querySelectorAll('input[data-filter-type="occasion"]')).find(cb => 
          cb.getAttribute('data-filter-value').trim() === value
        );
        if (checkbox) checkbox.checked = false;
        break;
      case 'personalised':
        this.state.filters.personalised = this.state.filters.personalised.filter(p => p !== value);
        checkbox = Array.from(document.querySelectorAll('input[data-filter-type="personalised"]')).find(cb => 
          cb.getAttribute('data-filter-value').trim() === value
        );
        if (checkbox) checkbox.checked = false;
        break;
      case 'recipient':
        this.state.filters.recipients = this.state.filters.recipients.filter(r => r !== value);
        checkbox = Array.from(document.querySelectorAll('input[data-filter-type="recipient"]')).find(cb => 
          cb.getAttribute('data-filter-value').trim() === value
        );
        if (checkbox) checkbox.checked = false;
        break;
      case 'size':
        this.state.filters.sizes = this.state.filters.sizes.filter(s => s !== value);
        checkbox = Array.from(document.querySelectorAll('input[data-filter-type="size"]')).find(cb => 
          cb.getAttribute('data-filter-value').trim() === value
        );
        if (checkbox) checkbox.checked = false;
        break;
      case 'vendor':
        this.state.filters.vendors = this.state.filters.vendors.filter(v => v !== value);
        checkbox = Array.from(document.querySelectorAll('input[data-filter-type="vendor"]')).find(cb => 
          cb.getAttribute('data-filter-value').trim() === value
        );
        if (checkbox) checkbox.checked = false;
        break;
      case 'availability':
        this.state.filters.availabilities = this.state.filters.availabilities.filter(a => a !== value);
        checkbox = Array.from(document.querySelectorAll('input[data-filter-type="availability"]')).find(cb => 
          cb.getAttribute('data-filter-value').trim() === value
        );
        if (checkbox) checkbox.checked = false;
        break;
      case 'christmas_type':
        this.state.filters.christmasTypes = this.state.filters.christmasTypes.filter(a => a !== value);
        checkbox = Array.from(document.querySelectorAll('input[data-filter-type="christmas_type"]')).find(cb => 
          cb.getAttribute('data-filter-value').trim() === value
        );
        if (checkbox) checkbox.checked = false;
        break;
      case 'stock':
        this.state.filters.hideOutOfStock = false;
        this.elements.hideOutOfStock.checked = false;
        break;
      case 'price':
        const defaultMin = parseInt(this.elements.priceMinRange.getAttribute('min')) || 0;
        const defaultMax = parseInt(this.elements.priceMaxRange.getAttribute('max')) || 1000;

        this.state.filters.priceMin = defaultMin;
        this.state.filters.priceMax = defaultMax;
        this.elements.priceMinRange.value = defaultMin;
        this.elements.priceMaxRange.value = defaultMax;
        if (this.elements.priceMinInput) this.elements.priceMinInput.value = defaultMin;
        if (this.elements.priceMaxInput) this.elements.priceMaxInput.value = defaultMax;
        this.updatePriceDisplay();
        break;
      default:
        // Handle custom filters (custom1, custom2, custom3, etc.)
        if (this.state.filters.customFilters[type]) {
          this.state.filters.customFilters[type] = this.state.filters.customFilters[type].filter(v => v !== value);
          checkbox = Array.from(document.querySelectorAll(`input[data-filter-type="${type}"]`)).find(cb => 
            cb.getAttribute('data-filter-value').trim() === value
          );
          if (checkbox) checkbox.checked = false;
        }
        break;
    }

    this.applyFilters();
  },

  // Clear all filters
  clearAllFilters() {
    // Get default values from ranges
    const defaultMin = parseInt(this.elements.priceMinRange.getAttribute('min')) || 0;
    const defaultMax = parseInt(this.elements.priceMaxRange.getAttribute('max')) || 1000;

    // Reset all filter states
    this.state.filters.search = '';
    this.state.filters.searchMobile = '';
    this.state.filters.hideOutOfStock = false;
    this.state.filters.priceMin = defaultMin;
    this.state.filters.priceMax = defaultMax;
    this.state.filters.categories = [];
    this.state.filters.occasions = [];
    this.state.filters.personalised = [];
    this.state.filters.recipients = [];
    this.state.filters.sizes = [];
    this.state.filters.vendors = [];
    this.state.filters.availabilities = [];
    this.state.filters.christmasTypes = [];
    this.state.filters.customFilters = {};

    // Reset UI elements
    this.elements.itemsSearch.value = '';
    this.elements.itemsSearchMobile.value = '';
    this.elements.hideOutOfStock.checked = false;
    this.elements.priceMinRange.value = defaultMin;
    this.elements.priceMaxRange.value = defaultMax;

    // Reset price input fields if they exist
    if (this.elements.priceMinInput) this.elements.priceMinInput.value = defaultMin;
    if (this.elements.priceMaxInput) this.elements.priceMaxInput.value = defaultMax;

    this.updatePriceDisplay();

    // Uncheck all filter checkboxes
    this.elements.filterOptions.forEach(option => {
      option.checked = false;
    });

    // Apply filters and update display
    this.applyFilters();
  },

  // Save progress to localStorage
  saveProgress() {
    const progress = {
      currentStep: this.state.currentStep,
      selectedBox: this.state.selectedBox,
      selectedItems: this.state.selectedItems,
      personalisations: this.state.personalisations,
      logoPersonalisations: this.state.logoPersonalisations,
      giftWrap: this.state.giftWrap,
      messaging: this.state.messaging,
      selectedThemedCard: this.state.selectedThemedCard,
      timestamp: Date.now()
    };
    localStorage.setItem('hamperBuilderProgress', JSON.stringify(progress));
  },

  loadProgress() {
    const progress = localStorage.getItem('hamperBuilderProgress');
    if (progress) {
      try {
        const parsed = JSON.parse(progress);
        this.state.currentStep = parsed.currentStep || 1;
        this.state.selectedBox = parsed.selectedBox || null;
        this.state.selectedItems = parsed.selectedItems || [];
        this.state.personalisations = parsed.personalisations || {};
        this.state.logoPersonalisations = parsed.logoPersonalisations || {};
        this.state.giftWrap = parsed.giftWrap || { selfWrap: false, paperQuantities: {}, penSellotape: false, wrappedItems: {} };
        this.state.selectedThemedCard = parsed.selectedThemedCard || null;
        this.state.messaging = parsed.messaging || {
          giftTag: false,
          giftTagTo: '',
          giftTagFrom: '',
          giftMessage: '',
          boxPersonalisation: '',
          boxInsideMessage: '',
          boxOutsideMessage: ''
        };
        if (this.pruneExcludedSelections()) {
          this.saveProgress();
        }
      } catch (e) {
        localStorage.removeItem('hamperBuilderProgress');
      }
    }
  },

  // Open product info modal
  openProductModal(productHandle) {
    console.log('Opening modal for product handle:', productHandle);
    
    if (!productHandle) {
      console.error('No product handle provided');
      alert('Could not load product information. Please try again.');
      return;
    }

    fetch(`/products/${productHandle}.js`)
      .then(response => {
        console.log('Fetch response status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        console.log('Product data loaded:', product);
        
        const modal = document.getElementById('product-info-modal');
        const modalImage = document.getElementById('modal-product-image');
        const modalTitle = document.getElementById('modal-product-title');
        const modalPrice = document.getElementById('modal-product-price');
        const modalDescription = document.getElementById('modal-product-description');
        const modalPersonalizeBadge = document.getElementById('modal-personalize-badge');
        const modalButton = document.getElementById('modal-add-to-cart-btn');

        // Set image
        if (product.featured_image) {
          modalImage.src = product.featured_image;
          modalImage.alt = product.title;
        } else if (product.images && product.images.length > 0) {
          modalImage.src = product.images[0];
          modalImage.alt = product.title;
        }

        // Set title
        modalTitle.textContent = product.title;

        // Set price
        const price = (product.price / 100).toFixed(2);
        const comparePrice = product.compare_at_price ? (product.compare_at_price / 100).toFixed(2) : null;
        
        if (comparePrice && comparePrice > price) {
          modalPrice.innerHTML = `
            <span class="price-sale">£${price}</span>
            <span class="price-compare">£${comparePrice}</span>
          `;
        } else {
          modalPrice.textContent = `£${price}`;
        }

        // Set description
        if (product.description) {
          modalDescription.innerHTML = product.description;
        } else {
          modalDescription.textContent = 'No description available.';
        }

        // Check for personalise tag
        const canPersonalise = product.tags && product.tags.some(tag => 
          tag.toLowerCase().includes('personalise') || tag.toLowerCase().includes('personalize')
        );
        modalPersonalizeBadge.style.display = canPersonalise ? 'block' : 'none';

        // Find the first available variant
        const firstAvailableVariant = product.variants.find(v => v.available) || product.variants[0];
        const variantId = firstAvailableVariant ? firstAvailableVariant.id : product.id;

        // Check if this item is already in the cart
        const isInCart = this.state.selectedItems.some(item => item.id === variantId);
        
        // Update button text and data
        modalButton.textContent = isInCart ? 'Remove from Cart' : 'Add to Cart';
        modalButton.setAttribute('data-product-id', variantId);
        modalButton.setAttribute('data-product-handle', productHandle);

        // Show modal
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      })
      .catch(error => {
        console.error('Error loading product:', error);
        console.error('Product handle was:', productHandle);
        alert('Could not load product information. Please try again.');
      });
  },

  // Close product info modal
  closeProductModal() {
    const modal = document.getElementById('product-info-modal');
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('build-your-own-app')) {
    BuildYourOwnHamper.init();

    // Setup modal close handlers
    const modal = document.getElementById('product-info-modal');
    const modalOverlay = modal?.querySelector('.product-info-modal-overlay');
    const modalCloseBtn = modal?.querySelector('.product-info-modal-close');
    const modalCloseBtnBottom = document.getElementById('modal-close-btn');

    if (modalOverlay) {
      modalOverlay.addEventListener('click', () => BuildYourOwnHamper.closeProductModal());
    }

    if (modalCloseBtn) {
      modalCloseBtn.addEventListener('click', () => BuildYourOwnHamper.closeProductModal());
    }

    // Handle the Add to Cart / Remove from Cart button
    const modalAddToCartBtn = document.getElementById('modal-add-to-cart-btn');
    if (modalAddToCartBtn) {
      modalAddToCartBtn.addEventListener('click', (e) => {
        const productId = parseInt(e.target.getAttribute('data-product-id'));
        console.log('Modal button clicked, product ID:', productId);
        
        if (productId) {
          // Find the add button for this product
          const addButton = document.querySelector(`.add-item-btn[data-product-id="${productId}"]`);
          console.log('Found add button:', addButton);
          
          if (addButton) {
            // Close modal first
            BuildYourOwnHamper.closeProductModal();
            
            // Trigger click on the add/remove button
            setTimeout(() => {
              console.log('Clicking add button');
              addButton.click();
            }, 100);
          } else {
            console.error('Could not find add button for product ID:', productId);
            BuildYourOwnHamper.closeProductModal();
          }
        } else {
          console.error('No product ID found on button');
          BuildYourOwnHamper.closeProductModal();
        }
      });
    }

    // Handle view-info link clicks using event delegation
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('product-view-info')) {
        e.preventDefault();
        console.log('View Info clicked', e.target);
        const productHandle = e.target.getAttribute('data-product-handle');
        console.log('Product handle from attribute:', productHandle);
        if (productHandle) {
          BuildYourOwnHamper.openProductModal(productHandle);
        } else {
          console.error('No product handle found on element:', e.target);
          alert('Product information is not available.');
        }
      }
    });

    // Close modal with Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const modal = document.getElementById('product-info-modal');
        if (modal && modal.classList.contains('active')) {
          BuildYourOwnHamper.closeProductModal();
        }
      }
    });
  }
});
